"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ic_24__7__support", {
  enumerable: true,
  get: function get() {
    return _ic_24__7__support.default;
  }
});
Object.defineProperty(exports, "ic_2g", {
  enumerable: true,
  get: function get() {
    return _ic_2g.default;
  }
});
Object.defineProperty(exports, "ic_360__degrees", {
  enumerable: true,
  get: function get() {
    return _ic_360__degrees.default;
  }
});
Object.defineProperty(exports, "ic_360__view", {
  enumerable: true,
  get: function get() {
    return _ic_360__view.default;
  }
});
Object.defineProperty(exports, "ic_3g", {
  enumerable: true,
  get: function get() {
    return _ic_3g.default;
  }
});
Object.defineProperty(exports, "ic_4K", {
  enumerable: true,
  get: function get() {
    return _ic_4k.default;
  }
});
Object.defineProperty(exports, "ic_4g__plus__plus", {
  enumerable: true,
  get: function get() {
    return _ic_4g__plus__plus.default;
  }
});
Object.defineProperty(exports, "ic_4g__plus", {
  enumerable: true,
  get: function get() {
    return _ic_4g__plus.default;
  }
});
Object.defineProperty(exports, "ic_4g", {
  enumerable: true,
  get: function get() {
    return _ic_4g.default;
  }
});
Object.defineProperty(exports, "ic_5G", {
  enumerable: true,
  get: function get() {
    return _ic_5g.default;
  }
});
Object.defineProperty(exports, "ic_APP_Channel_Management", {
  enumerable: true,
  get: function get() {
    return _ic_app_channel_management.default;
  }
});
Object.defineProperty(exports, "ic_APP_Channel_variety", {
  enumerable: true,
  get: function get() {
    return _ic_app_channel_variety.default;
  }
});
Object.defineProperty(exports, "ic_APP_EPG", {
  enumerable: true,
  get: function get() {
    return _ic_app_epg.default;
  }
});
Object.defineProperty(exports, "ic_APP_EPG_backwards", {
  enumerable: true,
  get: function get() {
    return _ic_app_epg_backwards.default;
  }
});
Object.defineProperty(exports, "ic_APP_HD", {
  enumerable: true,
  get: function get() {
    return _ic_app_hd.default;
  }
});
Object.defineProperty(exports, "ic_APP_TV", {
  enumerable: true,
  get: function get() {
    return _ic_app_tv.default;
  }
});
Object.defineProperty(exports, "ic_APP_UHD", {
  enumerable: true,
  get: function get() {
    return _ic_app_uhd.default;
  }
});
Object.defineProperty(exports, "ic_APP_VOD", {
  enumerable: true,
  get: function get() {
    return _ic_app_vod.default;
  }
});
Object.defineProperty(exports, "ic_APP_anytime", {
  enumerable: true,
  get: function get() {
    return _ic_app_anytime.default;
  }
});
Object.defineProperty(exports, "ic_APP_cloud_DVR", {
  enumerable: true,
  get: function get() {
    return _ic_app_cloud_dvr.default;
  }
});
Object.defineProperty(exports, "ic_APP_discovery", {
  enumerable: true,
  get: function get() {
    return _ic_app_discovery.default;
  }
});
Object.defineProperty(exports, "ic_APP_kids", {
  enumerable: true,
  get: function get() {
    return _ic_app_kids.default;
  }
});
Object.defineProperty(exports, "ic_APP_mediatheken", {
  enumerable: true,
  get: function get() {
    return _ic_app_mediatheken.default;
  }
});
Object.defineProperty(exports, "ic_APP_mobile_entertainment", {
  enumerable: true,
  get: function get() {
    return _ic_app_mobile_entertainment.default;
  }
});
Object.defineProperty(exports, "ic_APP_multiscreen", {
  enumerable: true,
  get: function get() {
    return _ic_app_multiscreen.default;
  }
});
Object.defineProperty(exports, "ic_APP_restart", {
  enumerable: true,
  get: function get() {
    return _ic_app_restart.default;
  }
});
Object.defineProperty(exports, "ic_APP_sideload", {
  enumerable: true,
  get: function get() {
    return _ic_app_sideload.default;
  }
});
Object.defineProperty(exports, "ic_APP_swipe_to_TV", {
  enumerable: true,
  get: function get() {
    return _ic_app_swipe_to_tv.default;
  }
});
Object.defineProperty(exports, "ic_APP_tv_for_you", {
  enumerable: true,
  get: function get() {
    return _ic_app_tv_for_you.default;
  }
});
Object.defineProperty(exports, "ic_APP_videostore", {
  enumerable: true,
  get: function get() {
    return _ic_app_videostore.default;
  }
});
Object.defineProperty(exports, "ic_AR", {
  enumerable: true,
  get: function get() {
    return _ic_ar.default;
  }
});
Object.defineProperty(exports, "ic_Convert_currency", {
  enumerable: true,
  get: function get() {
    return _ic_convert_currency.default;
  }
});
Object.defineProperty(exports, "ic_DWDM__muxer", {
  enumerable: true,
  get: function get() {
    return _ic_dwdm__muxer.default;
  }
});
Object.defineProperty(exports, "ic_GIGA_TV_A", {
  enumerable: true,
  get: function get() {
    return _ic_giga_tv_a.default;
  }
});
Object.defineProperty(exports, "ic_GIGA_TV_B", {
  enumerable: true,
  get: function get() {
    return _ic_giga_tv_b.default;
  }
});
Object.defineProperty(exports, "ic_Impact__alert", {
  enumerable: true,
  get: function get() {
    return _ic_impact__alert.default;
  }
});
Object.defineProperty(exports, "ic_Kippy__light", {
  enumerable: true,
  get: function get() {
    return _ic_kippy__light.default;
  }
});
Object.defineProperty(exports, "ic_Make_Payment", {
  enumerable: true,
  get: function get() {
    return _ic_make_payment.default;
  }
});
Object.defineProperty(exports, "ic_Move__money", {
  enumerable: true,
  get: function get() {
    return _ic_move__money.default;
  }
});
Object.defineProperty(exports, "ic_Move_Money", {
  enumerable: true,
  get: function get() {
    return _ic_move_money.default;
  }
});
Object.defineProperty(exports, "ic_NFC", {
  enumerable: true,
  get: function get() {
    return _ic_nfc.default;
  }
});
Object.defineProperty(exports, "ic_TV_Channel_Management", {
  enumerable: true,
  get: function get() {
    return _ic_tv_channel_management.default;
  }
});
Object.defineProperty(exports, "ic_TV_Channel_variety", {
  enumerable: true,
  get: function get() {
    return _ic_tv_channel_variety.default;
  }
});
Object.defineProperty(exports, "ic_TV_EPG", {
  enumerable: true,
  get: function get() {
    return _ic_tv_epg.default;
  }
});
Object.defineProperty(exports, "ic_TV_EPG_backwards", {
  enumerable: true,
  get: function get() {
    return _ic_tv_epg_backwards.default;
  }
});
Object.defineProperty(exports, "ic_TV_HD", {
  enumerable: true,
  get: function get() {
    return _ic_tv_hd.default;
  }
});
Object.defineProperty(exports, "ic_TV_PrimeTime", {
  enumerable: true,
  get: function get() {
    return _ic_tv_primetime.default;
  }
});
Object.defineProperty(exports, "ic_TV_TV", {
  enumerable: true,
  get: function get() {
    return _ic_tv_tv.default;
  }
});
Object.defineProperty(exports, "ic_TV_Time_flexible", {
  enumerable: true,
  get: function get() {
    return _ic_tv_time_flexible.default;
  }
});
Object.defineProperty(exports, "ic_TV_UHD", {
  enumerable: true,
  get: function get() {
    return _ic_tv_uhd.default;
  }
});
Object.defineProperty(exports, "ic_TV_VOD", {
  enumerable: true,
  get: function get() {
    return _ic_tv_vod.default;
  }
});
Object.defineProperty(exports, "ic_TV_anytime", {
  enumerable: true,
  get: function get() {
    return _ic_tv_anytime.default;
  }
});
Object.defineProperty(exports, "ic_TV_bluetooth_remote_A", {
  enumerable: true,
  get: function get() {
    return _ic_tv_bluetooth_remote_a.default;
  }
});
Object.defineProperty(exports, "ic_TV_bluetooth_remote_B", {
  enumerable: true,
  get: function get() {
    return _ic_tv_bluetooth_remote_b.default;
  }
});
Object.defineProperty(exports, "ic_TV_cloud_DVR", {
  enumerable: true,
  get: function get() {
    return _ic_tv_cloud_dvr.default;
  }
});
Object.defineProperty(exports, "ic_TV_discovery", {
  enumerable: true,
  get: function get() {
    return _ic_tv_discovery.default;
  }
});
Object.defineProperty(exports, "ic_TV_everywhere", {
  enumerable: true,
  get: function get() {
    return _ic_tv_everywhere.default;
  }
});
Object.defineProperty(exports, "ic_TV_everywhere_home", {
  enumerable: true,
  get: function get() {
    return _ic_tv_everywhere_home.default;
  }
});
Object.defineProperty(exports, "ic_TV_for_you", {
  enumerable: true,
  get: function get() {
    return _ic_tv_for_you.default;
  }
});
Object.defineProperty(exports, "ic_TV_kids", {
  enumerable: true,
  get: function get() {
    return _ic_tv_kids.default;
  }
});
Object.defineProperty(exports, "ic_TV_mediatheken", {
  enumerable: true,
  get: function get() {
    return _ic_tv_mediatheken.default;
  }
});
Object.defineProperty(exports, "ic_TV_multiscreen", {
  enumerable: true,
  get: function get() {
    return _ic_tv_multiscreen.default;
  }
});
Object.defineProperty(exports, "ic_TV_restart", {
  enumerable: true,
  get: function get() {
    return _ic_tv_restart.default;
  }
});
Object.defineProperty(exports, "ic_TV_storage", {
  enumerable: true,
  get: function get() {
    return _ic_tv_storage.default;
  }
});
Object.defineProperty(exports, "ic_TV_videostore", {
  enumerable: true,
  get: function get() {
    return _ic_tv_videostore.default;
  }
});
Object.defineProperty(exports, "ic_Withdraw_cash", {
  enumerable: true,
  get: function get() {
    return _ic_withdraw_cash.default;
  }
});
Object.defineProperty(exports, "ic_about", {
  enumerable: true,
  get: function get() {
    return _ic_about.default;
  }
});
Object.defineProperty(exports, "ic_abrupt__cornering", {
  enumerable: true,
  get: function get() {
    return _ic_abrupt__cornering.default;
  }
});
Object.defineProperty(exports, "ic_acceleration__low", {
  enumerable: true,
  get: function get() {
    return _ic_acceleration__low.default;
  }
});
Object.defineProperty(exports, "ic_accelerationdle", {
  enumerable: true,
  get: function get() {
    return _ic_accelerationdle.default;
  }
});
Object.defineProperty(exports, "ic_acceleration", {
  enumerable: true,
  get: function get() {
    return _ic_acceleration.default;
  }
});
Object.defineProperty(exports, "ic_accelerometer", {
  enumerable: true,
  get: function get() {
    return _ic_accelerometer.default;
  }
});
Object.defineProperty(exports, "ic_accessories", {
  enumerable: true,
  get: function get() {
    return _ic_accessories.default;
  }
});
Object.defineProperty(exports, "ic_activity", {
  enumerable: true,
  get: function get() {
    return _ic_activity.default;
  }
});
Object.defineProperty(exports, "ic_add__business__user", {
  enumerable: true,
  get: function get() {
    return _ic_add__business__user.default;
  }
});
Object.defineProperty(exports, "ic_add__friend", {
  enumerable: true,
  get: function get() {
    return _ic_add__friend.default;
  }
});
Object.defineProperty(exports, "ic_add__ons__boosts", {
  enumerable: true,
  get: function get() {
    return _ic_add__ons__boosts.default;
  }
});
Object.defineProperty(exports, "ic_add__or__plus", {
  enumerable: true,
  get: function get() {
    return _ic_add__or__plus.default;
  }
});
Object.defineProperty(exports, "ic_admin", {
  enumerable: true,
  get: function get() {
    return _ic_admin.default;
  }
});
Object.defineProperty(exports, "ic_adult", {
  enumerable: true,
  get: function get() {
    return _ic_adult.default;
  }
});
Object.defineProperty(exports, "ic_alarm__assistant__fire", {
  enumerable: true,
  get: function get() {
    return _ic_alarm__assistant__fire.default;
  }
});
Object.defineProperty(exports, "ic_alarm__assistant__leakage", {
  enumerable: true,
  get: function get() {
    return _ic_alarm__assistant__leakage.default;
  }
});
Object.defineProperty(exports, "ic_alarm__assistant", {
  enumerable: true,
  get: function get() {
    return _ic_alarm__assistant.default;
  }
});
Object.defineProperty(exports, "ic_alarm__system", {
  enumerable: true,
  get: function get() {
    return _ic_alarm__system.default;
  }
});
Object.defineProperty(exports, "ic_alexa", {
  enumerable: true,
  get: function get() {
    return _ic_alexa.default;
  }
});
Object.defineProperty(exports, "ic_all__rewards", {
  enumerable: true,
  get: function get() {
    return _ic_all__rewards.default;
  }
});
Object.defineProperty(exports, "ic_analyst__view", {
  enumerable: true,
  get: function get() {
    return _ic_analyst__view.default;
  }
});
Object.defineProperty(exports, "ic_android", {
  enumerable: true,
  get: function get() {
    return _ic_android.default;
  }
});
Object.defineProperty(exports, "ic_anti__shock", {
  enumerable: true,
  get: function get() {
    return _ic_anti__shock.default;
  }
});
Object.defineProperty(exports, "ic_app__anytime", {
  enumerable: true,
  get: function get() {
    return _ic_app__anytime.default;
  }
});
Object.defineProperty(exports, "ic_app__channel__management", {
  enumerable: true,
  get: function get() {
    return _ic_app__channel__management.default;
  }
});
Object.defineProperty(exports, "ic_app__channel__variety", {
  enumerable: true,
  get: function get() {
    return _ic_app__channel__variety.default;
  }
});
Object.defineProperty(exports, "ic_app__cloud__dvr", {
  enumerable: true,
  get: function get() {
    return _ic_app__cloud__dvr.default;
  }
});
Object.defineProperty(exports, "ic_app__discovery", {
  enumerable: true,
  get: function get() {
    return _ic_app__discovery.default;
  }
});
Object.defineProperty(exports, "ic_app__epg__backwards", {
  enumerable: true,
  get: function get() {
    return _ic_app__epg__backwards.default;
  }
});
Object.defineProperty(exports, "ic_app__epg", {
  enumerable: true,
  get: function get() {
    return _ic_app__epg.default;
  }
});
Object.defineProperty(exports, "ic_app__hd", {
  enumerable: true,
  get: function get() {
    return _ic_app__hd.default;
  }
});
Object.defineProperty(exports, "ic_app__kids", {
  enumerable: true,
  get: function get() {
    return _ic_app__kids.default;
  }
});
Object.defineProperty(exports, "ic_app__mediatheken", {
  enumerable: true,
  get: function get() {
    return _ic_app__mediatheken.default;
  }
});
Object.defineProperty(exports, "ic_app__mobile__entertainment", {
  enumerable: true,
  get: function get() {
    return _ic_app__mobile__entertainment.default;
  }
});
Object.defineProperty(exports, "ic_app__multiscreen", {
  enumerable: true,
  get: function get() {
    return _ic_app__multiscreen.default;
  }
});
Object.defineProperty(exports, "ic_app__restart", {
  enumerable: true,
  get: function get() {
    return _ic_app__restart.default;
  }
});
Object.defineProperty(exports, "ic_app__sideload", {
  enumerable: true,
  get: function get() {
    return _ic_app__sideload.default;
  }
});
Object.defineProperty(exports, "ic_app__store", {
  enumerable: true,
  get: function get() {
    return _ic_app__store.default;
  }
});
Object.defineProperty(exports, "ic_app__swipe__to__tv", {
  enumerable: true,
  get: function get() {
    return _ic_app__swipe__to__tv.default;
  }
});
Object.defineProperty(exports, "ic_app__tv__for__you", {
  enumerable: true,
  get: function get() {
    return _ic_app__tv__for__you.default;
  }
});
Object.defineProperty(exports, "ic_app__tv", {
  enumerable: true,
  get: function get() {
    return _ic_app__tv.default;
  }
});
Object.defineProperty(exports, "ic_app__uhd", {
  enumerable: true,
  get: function get() {
    return _ic_app__uhd.default;
  }
});
Object.defineProperty(exports, "ic_app__videostore", {
  enumerable: true,
  get: function get() {
    return _ic_app__videostore.default;
  }
});
Object.defineProperty(exports, "ic_app__vod", {
  enumerable: true,
  get: function get() {
    return _ic_app__vod.default;
  }
});
Object.defineProperty(exports, "ic_apps", {
  enumerable: true,
  get: function get() {
    return _ic_apps.default;
  }
});
Object.defineProperty(exports, "ic_arrow__down", {
  enumerable: true,
  get: function get() {
    return _ic_arrow__down.default;
  }
});
Object.defineProperty(exports, "ic_arrow__left", {
  enumerable: true,
  get: function get() {
    return _ic_arrow__left.default;
  }
});
Object.defineProperty(exports, "ic_arrow__right", {
  enumerable: true,
  get: function get() {
    return _ic_arrow__right.default;
  }
});
Object.defineProperty(exports, "ic_arrow__up", {
  enumerable: true,
  get: function get() {
    return _ic_arrow__up.default;
  }
});
Object.defineProperty(exports, "ic_attachment", {
  enumerable: true,
  get: function get() {
    return _ic_attachment.default;
  }
});
Object.defineProperty(exports, "ic_auto__top__up", {
  enumerable: true,
  get: function get() {
    return _ic_auto__top__up.default;
  }
});
Object.defineProperty(exports, "ic_backspace", {
  enumerable: true,
  get: function get() {
    return _ic_backspace.default;
  }
});
Object.defineProperty(exports, "ic_band__on__charge", {
  enumerable: true,
  get: function get() {
    return _ic_band__on__charge.default;
  }
});
Object.defineProperty(exports, "ic_barcode", {
  enumerable: true,
  get: function get() {
    return _ic_barcode.default;
  }
});
Object.defineProperty(exports, "ic_battery__low", {
  enumerable: true,
  get: function get() {
    return _ic_battery__low.default;
  }
});
Object.defineProperty(exports, "ic_battery__really__low", {
  enumerable: true,
  get: function get() {
    return _ic_battery__really__low.default;
  }
});
Object.defineProperty(exports, "ic_battery", {
  enumerable: true,
  get: function get() {
    return _ic_battery.default;
  }
});
Object.defineProperty(exports, "ic_bill__or__report", {
  enumerable: true,
  get: function get() {
    return _ic_bill__or__report.default;
  }
});
Object.defineProperty(exports, "ic_bill", {
  enumerable: true,
  get: function get() {
    return _ic_bill.default;
  }
});
Object.defineProperty(exports, "ic_biometric__authentication__new", {
  enumerable: true,
  get: function get() {
    return _ic_biometric__authentication__new.default;
  }
});
Object.defineProperty(exports, "ic_biometric_authentication", {
  enumerable: true,
  get: function get() {
    return _ic_biometric_authentication.default;
  }
});
Object.defineProperty(exports, "ic_birthday__greeting", {
  enumerable: true,
  get: function get() {
    return _ic_birthday__greeting.default;
  }
});
Object.defineProperty(exports, "ic_block", {
  enumerable: true,
  get: function get() {
    return _ic_block.default;
  }
});
Object.defineProperty(exports, "ic_blog", {
  enumerable: true,
  get: function get() {
    return _ic_blog.default;
  }
});
Object.defineProperty(exports, "ic_bluetooth", {
  enumerable: true,
  get: function get() {
    return _ic_bluetooth.default;
  }
});
Object.defineProperty(exports, "ic_bold", {
  enumerable: true,
  get: function get() {
    return _ic_bold.default;
  }
});
Object.defineProperty(exports, "ic_bolt", {
  enumerable: true,
  get: function get() {
    return _ic_bolt.default;
  }
});
Object.defineProperty(exports, "ic_book", {
  enumerable: true,
  get: function get() {
    return _ic_book.default;
  }
});
Object.defineProperty(exports, "ic_bookmark", {
  enumerable: true,
  get: function get() {
    return _ic_bookmark.default;
  }
});
Object.defineProperty(exports, "ic_boosting__pause", {
  enumerable: true,
  get: function get() {
    return _ic_boosting__pause.default;
  }
});
Object.defineProperty(exports, "ic_boosting", {
  enumerable: true,
  get: function get() {
    return _ic_boosting.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__active", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__active.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__disabled", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__disabled.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__generic", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__generic.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__not__found", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__not__found.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__off", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__off.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__on", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__on.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__put__on", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__put__on.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__remove", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__remove.default;
  }
});
Object.defineProperty(exports, "ic_braking", {
  enumerable: true,
  get: function get() {
    return _ic_braking.default;
  }
});
Object.defineProperty(exports, "ic_broadband__or__wifi", {
  enumerable: true,
  get: function get() {
    return _ic_broadband__or__wifi.default;
  }
});
Object.defineProperty(exports, "ic_broadband", {
  enumerable: true,
  get: function get() {
    return _ic_broadband.default;
  }
});
Object.defineProperty(exports, "ic_bullet__list", {
  enumerable: true,
  get: function get() {
    return _ic_bullet__list.default;
  }
});
Object.defineProperty(exports, "ic_bundles", {
  enumerable: true,
  get: function get() {
    return _ic_bundles.default;
  }
});
Object.defineProperty(exports, "ic_business__phone", {
  enumerable: true,
  get: function get() {
    return _ic_business__phone.default;
  }
});
Object.defineProperty(exports, "ic_business", {
  enumerable: true,
  get: function get() {
    return _ic_business.default;
  }
});
Object.defineProperty(exports, "ic_calculator", {
  enumerable: true,
  get: function get() {
    return _ic_calculator.default;
  }
});
Object.defineProperty(exports, "ic_calendar", {
  enumerable: true,
  get: function get() {
    return _ic_calendar.default;
  }
});
Object.defineProperty(exports, "ic_call__log", {
  enumerable: true,
  get: function get() {
    return _ic_call__log.default;
  }
});
Object.defineProperty(exports, "ic_call__quality__excellent", {
  enumerable: true,
  get: function get() {
    return _ic_call__quality__excellent.default;
  }
});
Object.defineProperty(exports, "ic_call__quality__good", {
  enumerable: true,
  get: function get() {
    return _ic_call__quality__good.default;
  }
});
Object.defineProperty(exports, "ic_call__quality__poor", {
  enumerable: true,
  get: function get() {
    return _ic_call__quality__poor.default;
  }
});
Object.defineProperty(exports, "ic_call", {
  enumerable: true,
  get: function get() {
    return _ic_call.default;
  }
});
Object.defineProperty(exports, "ic_calls__contacts", {
  enumerable: true,
  get: function get() {
    return _ic_calls__contacts.default;
  }
});
Object.defineProperty(exports, "ic_camera", {
  enumerable: true,
  get: function get() {
    return _ic_camera.default;
  }
});
Object.defineProperty(exports, "ic_car__key", {
  enumerable: true,
  get: function get() {
    return _ic_car__key.default;
  }
});
Object.defineProperty(exports, "ic_car", {
  enumerable: true,
  get: function get() {
    return _ic_car.default;
  }
});
Object.defineProperty(exports, "ic_careers", {
  enumerable: true,
  get: function get() {
    return _ic_careers.default;
  }
});
Object.defineProperty(exports, "ic_carer", {
  enumerable: true,
  get: function get() {
    return _ic_carer.default;
  }
});
Object.defineProperty(exports, "ic_case__study", {
  enumerable: true,
  get: function get() {
    return _ic_case__study.default;
  }
});
Object.defineProperty(exports, "ic_celebrate", {
  enumerable: true,
  get: function get() {
    return _ic_celebrate.default;
  }
});
Object.defineProperty(exports, "ic_charge__to__bill", {
  enumerable: true,
  get: function get() {
    return _ic_charge__to__bill.default;
  }
});
Object.defineProperty(exports, "ic_charity__giving", {
  enumerable: true,
  get: function get() {
    return _ic_charity__giving.default;
  }
});
Object.defineProperty(exports, "ic_chart__bar", {
  enumerable: true,
  get: function get() {
    return _ic_chart__bar.default;
  }
});
Object.defineProperty(exports, "ic_chart__line", {
  enumerable: true,
  get: function get() {
    return _ic_chart__line.default;
  }
});
Object.defineProperty(exports, "ic_chat", {
  enumerable: true,
  get: function get() {
    return _ic_chat.default;
  }
});
Object.defineProperty(exports, "ic_chatbot__robot", {
  enumerable: true,
  get: function get() {
    return _ic_chatbot__robot.default;
  }
});
Object.defineProperty(exports, "ic_cherries__points", {
  enumerable: true,
  get: function get() {
    return _ic_cherries__points.default;
  }
});
Object.defineProperty(exports, "ic_chevron__down", {
  enumerable: true,
  get: function get() {
    return _ic_chevron__down.default;
  }
});
Object.defineProperty(exports, "ic_chevron__left", {
  enumerable: true,
  get: function get() {
    return _ic_chevron__left.default;
  }
});
Object.defineProperty(exports, "ic_chevron__right", {
  enumerable: true,
  get: function get() {
    return _ic_chevron__right.default;
  }
});
Object.defineProperty(exports, "ic_chevron__up", {
  enumerable: true,
  get: function get() {
    return _ic_chevron__up.default;
  }
});
Object.defineProperty(exports, "ic_child__tracker", {
  enumerable: true,
  get: function get() {
    return _ic_child__tracker.default;
  }
});
Object.defineProperty(exports, "ic_chromecast", {
  enumerable: true,
  get: function get() {
    return _ic_chromecast.default;
  }
});
Object.defineProperty(exports, "ic_clapping", {
  enumerable: true,
  get: function get() {
    return _ic_clapping.default;
  }
});
Object.defineProperty(exports, "ic_click__collect", {
  enumerable: true,
  get: function get() {
    return _ic_click__collect.default;
  }
});
Object.defineProperty(exports, "ic_clock__or__timed", {
  enumerable: true,
  get: function get() {
    return _ic_clock__or__timed.default;
  }
});
Object.defineProperty(exports, "ic_clock", {
  enumerable: true,
  get: function get() {
    return _ic_clock.default;
  }
});
Object.defineProperty(exports, "ic_close", {
  enumerable: true,
  get: function get() {
    return _ic_close.default;
  }
});
Object.defineProperty(exports, "ic_cloud__download", {
  enumerable: true,
  get: function get() {
    return _ic_cloud__download.default;
  }
});
Object.defineProperty(exports, "ic_cloud__hosting", {
  enumerable: true,
  get: function get() {
    return _ic_cloud__hosting.default;
  }
});
Object.defineProperty(exports, "ic_cloud__upload", {
  enumerable: true,
  get: function get() {
    return _ic_cloud__upload.default;
  }
});
Object.defineProperty(exports, "ic_cluster__of__events", {
  enumerable: true,
  get: function get() {
    return _ic_cluster__of__events.default;
  }
});
Object.defineProperty(exports, "ic_colour__palette", {
  enumerable: true,
  get: function get() {
    return _ic_colour__palette.default;
  }
});
Object.defineProperty(exports, "ic_comment", {
  enumerable: true,
  get: function get() {
    return _ic_comment.default;
  }
});
Object.defineProperty(exports, "ic_community__or__foundation", {
  enumerable: true,
  get: function get() {
    return _ic_community__or__foundation.default;
  }
});
Object.defineProperty(exports, "ic_community", {
  enumerable: true,
  get: function get() {
    return _ic_community.default;
  }
});
Object.defineProperty(exports, "ic_compass", {
  enumerable: true,
  get: function get() {
    return _ic_compass.default;
  }
});
Object.defineProperty(exports, "ic_complaints", {
  enumerable: true,
  get: function get() {
    return _ic_complaints.default;
  }
});
Object.defineProperty(exports, "ic_completed", {
  enumerable: true,
  get: function get() {
    return _ic_completed.default;
  }
});
Object.defineProperty(exports, "ic_confidential", {
  enumerable: true,
  get: function get() {
    return _ic_confidential.default;
  }
});
Object.defineProperty(exports, "ic_connected__car", {
  enumerable: true,
  get: function get() {
    return _ic_connected__car.default;
  }
});
Object.defineProperty(exports, "ic_connected__devices", {
  enumerable: true,
  get: function get() {
    return _ic_connected__devices.default;
  }
});
Object.defineProperty(exports, "ic_connected", {
  enumerable: true,
  get: function get() {
    return _ic_connected.default;
  }
});
Object.defineProperty(exports, "ic_connectedices", {
  enumerable: true,
  get: function get() {
    return _ic_connectedices.default;
  }
});
Object.defineProperty(exports, "ic_connectivity", {
  enumerable: true,
  get: function get() {
    return _ic_connectivity.default;
  }
});
Object.defineProperty(exports, "ic_connects__home__to__phone", {
  enumerable: true,
  get: function get() {
    return _ic_connects__home__to__phone.default;
  }
});
Object.defineProperty(exports, "ic_consultant", {
  enumerable: true,
  get: function get() {
    return _ic_consultant.default;
  }
});
Object.defineProperty(exports, "ic_contactless__payment", {
  enumerable: true,
  get: function get() {
    return _ic_contactless__payment.default;
  }
});
Object.defineProperty(exports, "ic_contest", {
  enumerable: true,
  get: function get() {
    return _ic_contest.default;
  }
});
Object.defineProperty(exports, "ic_control__panel", {
  enumerable: true,
  get: function get() {
    return _ic_control__panel.default;
  }
});
Object.defineProperty(exports, "ic_converged__proposition", {
  enumerable: true,
  get: function get() {
    return _ic_converged__proposition.default;
  }
});
Object.defineProperty(exports, "ic_cost__control", {
  enumerable: true,
  get: function get() {
    return _ic_cost__control.default;
  }
});
Object.defineProperty(exports, "ic_country__or__international", {
  enumerable: true,
  get: function get() {
    return _ic_country__or__international.default;
  }
});
Object.defineProperty(exports, "ic_cpu", {
  enumerable: true,
  get: function get() {
    return _ic_cpu.default;
  }
});
Object.defineProperty(exports, "ic_customer__care", {
  enumerable: true,
  get: function get() {
    return _ic_customer__care.default;
  }
});
Object.defineProperty(exports, "ic_customers__or__users", {
  enumerable: true,
  get: function get() {
    return _ic_customers__or__users.default;
  }
});
Object.defineProperty(exports, "ic_cvv", {
  enumerable: true,
  get: function get() {
    return _ic_cvv.default;
  }
});
Object.defineProperty(exports, "ic_dashboard__in__app", {
  enumerable: true,
  get: function get() {
    return _ic_dashboard__in__app.default;
  }
});
Object.defineProperty(exports, "ic_dashboard", {
  enumerable: true,
  get: function get() {
    return _ic_dashboard.default;
  }
});
Object.defineProperty(exports, "ic_data", {
  enumerable: true,
  get: function get() {
    return _ic_data.default;
  }
});
Object.defineProperty(exports, "ic_deals", {
  enumerable: true,
  get: function get() {
    return _ic_deals.default;
  }
});
Object.defineProperty(exports, "ic_delete", {
  enumerable: true,
  get: function get() {
    return _ic_delete.default;
  }
});
Object.defineProperty(exports, "ic_delivery", {
  enumerable: true,
  get: function get() {
    return _ic_delivery.default;
  }
});
Object.defineProperty(exports, "ic_desktop", {
  enumerable: true,
  get: function get() {
    return _ic_desktop.default;
  }
});
Object.defineProperty(exports, "ic_device__diagnostics", {
  enumerable: true,
  get: function get() {
    return _ic_device__diagnostics.default;
  }
});
Object.defineProperty(exports, "ic_device__guide", {
  enumerable: true,
  get: function get() {
    return _ic_device__guide.default;
  }
});
Object.defineProperty(exports, "ic_device__overview__iot", {
  enumerable: true,
  get: function get() {
    return _ic_device__overview__iot.default;
  }
});
Object.defineProperty(exports, "ic_device__thickness", {
  enumerable: true,
  get: function get() {
    return _ic_device__thickness.default;
  }
});
Object.defineProperty(exports, "ic_diagnostics", {
  enumerable: true,
  get: function get() {
    return _ic_diagnostics.default;
  }
});
Object.defineProperty(exports, "ic_dial__pad", {
  enumerable: true,
  get: function get() {
    return _ic_dial__pad.default;
  }
});
Object.defineProperty(exports, "ic_dislike", {
  enumerable: true,
  get: function get() {
    return _ic_dislike.default;
  }
});
Object.defineProperty(exports, "ic_document__doc", {
  enumerable: true,
  get: function get() {
    return _ic_document__doc.default;
  }
});
Object.defineProperty(exports, "ic_document__jpg", {
  enumerable: true,
  get: function get() {
    return _ic_document__jpg.default;
  }
});
Object.defineProperty(exports, "ic_document__pdf", {
  enumerable: true,
  get: function get() {
    return _ic_document__pdf.default;
  }
});
Object.defineProperty(exports, "ic_document__png", {
  enumerable: true,
  get: function get() {
    return _ic_document__png.default;
  }
});
Object.defineProperty(exports, "ic_document__ppt", {
  enumerable: true,
  get: function get() {
    return _ic_document__ppt.default;
  }
});
Object.defineProperty(exports, "ic_document__rtf", {
  enumerable: true,
  get: function get() {
    return _ic_document__rtf.default;
  }
});
Object.defineProperty(exports, "ic_document__svg", {
  enumerable: true,
  get: function get() {
    return _ic_document__svg.default;
  }
});
Object.defineProperty(exports, "ic_document__xls", {
  enumerable: true,
  get: function get() {
    return _ic_document__xls.default;
  }
});
Object.defineProperty(exports, "ic_document__zip", {
  enumerable: true,
  get: function get() {
    return _ic_document__zip.default;
  }
});
Object.defineProperty(exports, "ic_document", {
  enumerable: true,
  get: function get() {
    return _ic_document.default;
  }
});
Object.defineProperty(exports, "ic_doorbell__camera", {
  enumerable: true,
  get: function get() {
    return _ic_doorbell__camera.default;
  }
});
Object.defineProperty(exports, "ic_double__stacked__pallet", {
  enumerable: true,
  get: function get() {
    return _ic_double__stacked__pallet.default;
  }
});
Object.defineProperty(exports, "ic_download__cloud", {
  enumerable: true,
  get: function get() {
    return _ic_download__cloud.default;
  }
});
Object.defineProperty(exports, "ic_download", {
  enumerable: true,
  get: function get() {
    return _ic_download.default;
  }
});
Object.defineProperty(exports, "ic_drone", {
  enumerable: true,
  get: function get() {
    return _ic_drone.default;
  }
});
Object.defineProperty(exports, "ic_e__sim", {
  enumerable: true,
  get: function get() {
    return _ic_e__sim.default;
  }
});
Object.defineProperty(exports, "ic_edit", {
  enumerable: true,
  get: function get() {
    return _ic_edit.default;
  }
});
Object.defineProperty(exports, "ic_end__call", {
  enumerable: true,
  get: function get() {
    return _ic_end__call.default;
  }
});
Object.defineProperty(exports, "ic_engineer", {
  enumerable: true,
  get: function get() {
    return _ic_engineer.default;
  }
});
Object.defineProperty(exports, "ic_enterprise", {
  enumerable: true,
  get: function get() {
    return _ic_enterprise.default;
  }
});
Object.defineProperty(exports, "ic_entertainment", {
  enumerable: true,
  get: function get() {
    return _ic_entertainment.default;
  }
});
Object.defineProperty(exports, "ic_environment", {
  enumerable: true,
  get: function get() {
    return _ic_environment.default;
  }
});
Object.defineProperty(exports, "ic_error__circle", {
  enumerable: true,
  get: function get() {
    return _ic_error__circle.default;
  }
});
Object.defineProperty(exports, "ic_error__simple", {
  enumerable: true,
  get: function get() {
    return _ic_error__simple.default;
  }
});
Object.defineProperty(exports, "ic_explorer", {
  enumerable: true,
  get: function get() {
    return _ic_explorer.default;
  }
});
Object.defineProperty(exports, "ic_extras__and__services", {
  enumerable: true,
  get: function get() {
    return _ic_extras__and__services.default;
  }
});
Object.defineProperty(exports, "ic_face__recognition", {
  enumerable: true,
  get: function get() {
    return _ic_face__recognition.default;
  }
});
Object.defineProperty(exports, "ic_facebook", {
  enumerable: true,
  get: function get() {
    return _ic_facebook.default;
  }
});
Object.defineProperty(exports, "ic_failed", {
  enumerable: true,
  get: function get() {
    return _ic_failed.default;
  }
});
Object.defineProperty(exports, "ic_fall__detection__emergency", {
  enumerable: true,
  get: function get() {
    return _ic_fall__detection__emergency.default;
  }
});
Object.defineProperty(exports, "ic_family", {
  enumerable: true,
  get: function get() {
    return _ic_family.default;
  }
});
Object.defineProperty(exports, "ic_filter", {
  enumerable: true,
  get: function get() {
    return _ic_filter.default;
  }
});
Object.defineProperty(exports, "ic_filters", {
  enumerable: true,
  get: function get() {
    return _ic_filters.default;
  }
});
Object.defineProperty(exports, "ic_find__and__ring__your__device", {
  enumerable: true,
  get: function get() {
    return _ic_find__and__ring__your__device.default;
  }
});
Object.defineProperty(exports, "ic_find__and__ring__yourice", {
  enumerable: true,
  get: function get() {
    return _ic_find__and__ring__yourice.default;
  }
});
Object.defineProperty(exports, "ic_find__my__car", {
  enumerable: true,
  get: function get() {
    return _ic_find__my__car.default;
  }
});
Object.defineProperty(exports, "ic_firmware__update", {
  enumerable: true,
  get: function get() {
    return _ic_firmware__update.default;
  }
});
Object.defineProperty(exports, "ic_fitness__tracker", {
  enumerable: true,
  get: function get() {
    return _ic_fitness__tracker.default;
  }
});
Object.defineProperty(exports, "ic_fixed__line", {
  enumerable: true,
  get: function get() {
    return _ic_fixed__line.default;
  }
});
Object.defineProperty(exports, "ic_focus", {
  enumerable: true,
  get: function get() {
    return _ic_focus.default;
  }
});
Object.defineProperty(exports, "ic_folder", {
  enumerable: true,
  get: function get() {
    return _ic_folder.default;
  }
});
Object.defineProperty(exports, "ic_forum", {
  enumerable: true,
  get: function get() {
    return _ic_forum.default;
  }
});
Object.defineProperty(exports, "ic_forward", {
  enumerable: true,
  get: function get() {
    return _ic_forward.default;
  }
});
Object.defineProperty(exports, "ic_free__delivery", {
  enumerable: true,
  get: function get() {
    return _ic_free__delivery.default;
  }
});
Object.defineProperty(exports, "ic_game__console", {
  enumerable: true,
  get: function get() {
    return _ic_game__console.default;
  }
});
Object.defineProperty(exports, "ic_generic__device__iot", {
  enumerable: true,
  get: function get() {
    return _ic_generic__device__iot.default;
  }
});
Object.defineProperty(exports, "ic_generic__tariff__plan", {
  enumerable: true,
  get: function get() {
    return _ic_generic__tariff__plan.default;
  }
});
Object.defineProperty(exports, "ic_genericice__iot", {
  enumerable: true,
  get: function get() {
    return _ic_genericice__iot.default;
  }
});
Object.defineProperty(exports, "ic_giga__tv__a", {
  enumerable: true,
  get: function get() {
    return _ic_giga__tv__a.default;
  }
});
Object.defineProperty(exports, "ic_giga__tv__b", {
  enumerable: true,
  get: function get() {
    return _ic_giga__tv__b.default;
  }
});
Object.defineProperty(exports, "ic_google__plus", {
  enumerable: true,
  get: function get() {
    return _ic_google__plus.default;
  }
});
Object.defineProperty(exports, "ic_gps__coverage", {
  enumerable: true,
  get: function get() {
    return _ic_gps__coverage.default;
  }
});
Object.defineProperty(exports, "ic_gravity", {
  enumerable: true,
  get: function get() {
    return _ic_gravity.default;
  }
});
Object.defineProperty(exports, "ic_grid__view", {
  enumerable: true,
  get: function get() {
    return _ic_grid__view.default;
  }
});
Object.defineProperty(exports, "ic_gyroscope", {
  enumerable: true,
  get: function get() {
    return _ic_gyroscope.default;
  }
});
Object.defineProperty(exports, "ic_healthy__living__favourites", {
  enumerable: true,
  get: function get() {
    return _ic_healthy__living__favourites.default;
  }
});
Object.defineProperty(exports, "ic_healthy__living", {
  enumerable: true,
  get: function get() {
    return _ic_healthy__living.default;
  }
});
Object.defineProperty(exports, "ic_help__at__hand", {
  enumerable: true,
  get: function get() {
    return _ic_help__at__hand.default;
  }
});
Object.defineProperty(exports, "ic_help__circle", {
  enumerable: true,
  get: function get() {
    return _ic_help__circle.default;
  }
});
Object.defineProperty(exports, "ic_help", {
  enumerable: true,
  get: function get() {
    return _ic_help.default;
  }
});
Object.defineProperty(exports, "ic_home", {
  enumerable: true,
  get: function get() {
    return _ic_home.default;
  }
});
Object.defineProperty(exports, "ic_idea__innovation", {
  enumerable: true,
  get: function get() {
    return _ic_idea__innovation.default;
  }
});
Object.defineProperty(exports, "ic_idea__or_innovation", {
  enumerable: true,
  get: function get() {
    return _ic_idea__or_innovation.default;
  }
});
Object.defineProperty(exports, "ic_idea__or__innovation__new", {
  enumerable: true,
  get: function get() {
    return _ic_idea__or__innovation__new.default;
  }
});
Object.defineProperty(exports, "ic_important__numbers", {
  enumerable: true,
  get: function get() {
    return _ic_important__numbers.default;
  }
});
Object.defineProperty(exports, "ic_incoming__call", {
  enumerable: true,
  get: function get() {
    return _ic_incoming__call.default;
  }
});
Object.defineProperty(exports, "ic_info__circle", {
  enumerable: true,
  get: function get() {
    return _ic_info__circle.default;
  }
});
Object.defineProperty(exports, "ic_info", {
  enumerable: true,
  get: function get() {
    return _ic_info.default;
  }
});
Object.defineProperty(exports, "ic_infographic", {
  enumerable: true,
  get: function get() {
    return _ic_infographic.default;
  }
});
Object.defineProperty(exports, "ic_insert__code", {
  enumerable: true,
  get: function get() {
    return _ic_insert__code.default;
  }
});
Object.defineProperty(exports, "ic_insights", {
  enumerable: true,
  get: function get() {
    return _ic_insights.default;
  }
});
Object.defineProperty(exports, "ic_insurance", {
  enumerable: true,
  get: function get() {
    return _ic_insurance.default;
  }
});
Object.defineProperty(exports, "ic_intelligence__scan", {
  enumerable: true,
  get: function get() {
    return _ic_intelligence__scan.default;
  }
});
Object.defineProperty(exports, "ic_interchangable__batteries", {
  enumerable: true,
  get: function get() {
    return _ic_interchangable__batteries.default;
  }
});
Object.defineProperty(exports, "ic_international__minutes", {
  enumerable: true,
  get: function get() {
    return _ic_international__minutes.default;
  }
});
Object.defineProperty(exports, "ic_internet__configurations", {
  enumerable: true,
  get: function get() {
    return _ic_internet__configurations.default;
  }
});
Object.defineProperty(exports, "ic_iris__scanner", {
  enumerable: true,
  get: function get() {
    return _ic_iris__scanner.default;
  }
});
Object.defineProperty(exports, "ic_italic", {
  enumerable: true,
  get: function get() {
    return _ic_italic.default;
  }
});
Object.defineProperty(exports, "ic_kids__watch", {
  enumerable: true,
  get: function get() {
    return _ic_kids__watch.default;
  }
});
Object.defineProperty(exports, "ic_kippy__device", {
  enumerable: true,
  get: function get() {
    return _ic_kippy__device.default;
  }
});
Object.defineProperty(exports, "ic_kippyice", {
  enumerable: true,
  get: function get() {
    return _ic_kippyice.default;
  }
});
Object.defineProperty(exports, "ic_landline__or__call", {
  enumerable: true,
  get: function get() {
    return _ic_landline__or__call.default;
  }
});
Object.defineProperty(exports, "ic_landline_internet", {
  enumerable: true,
  get: function get() {
    return _ic_landline_internet.default;
  }
});
Object.defineProperty(exports, "ic_lateral__movement", {
  enumerable: true,
  get: function get() {
    return _ic_lateral__movement.default;
  }
});
Object.defineProperty(exports, "ic_like", {
  enumerable: true,
  get: function get() {
    return _ic_like.default;
  }
});
Object.defineProperty(exports, "ic_link__insert__edit", {
  enumerable: true,
  get: function get() {
    return _ic_link__insert__edit.default;
  }
});
Object.defineProperty(exports, "ic_linkedin", {
  enumerable: true,
  get: function get() {
    return _ic_linkedin.default;
  }
});
Object.defineProperty(exports, "ic_list__view", {
  enumerable: true,
  get: function get() {
    return _ic_list__view.default;
  }
});
Object.defineProperty(exports, "ic_loan", {
  enumerable: true,
  get: function get() {
    return _ic_loan.default;
  }
});
Object.defineProperty(exports, "ic_locate__me", {
  enumerable: true,
  get: function get() {
    return _ic_locate__me.default;
  }
});
Object.defineProperty(exports, "ic_location__alert", {
  enumerable: true,
  get: function get() {
    return _ic_location__alert.default;
  }
});
Object.defineProperty(exports, "ic_location", {
  enumerable: true,
  get: function get() {
    return _ic_location.default;
  }
});
Object.defineProperty(exports, "ic_log__in", {
  enumerable: true,
  get: function get() {
    return _ic_log__in.default;
  }
});
Object.defineProperty(exports, "ic_log__out", {
  enumerable: true,
  get: function get() {
    return _ic_log__out.default;
  }
});
Object.defineProperty(exports, "ic_mail__new", {
  enumerable: true,
  get: function get() {
    return _ic_mail__new.default;
  }
});
Object.defineProperty(exports, "ic_mail__read", {
  enumerable: true,
  get: function get() {
    return _ic_mail__read.default;
  }
});
Object.defineProperty(exports, "ic_mail", {
  enumerable: true,
  get: function get() {
    return _ic_mail.default;
  }
});
Object.defineProperty(exports, "ic_map", {
  enumerable: true,
  get: function get() {
    return _ic_map.default;
  }
});
Object.defineProperty(exports, "ic_measure", {
  enumerable: true,
  get: function get() {
    return _ic_measure.default;
  }
});
Object.defineProperty(exports, "ic_members", {
  enumerable: true,
  get: function get() {
    return _ic_members.default;
  }
});
Object.defineProperty(exports, "ic_menu", {
  enumerable: true,
  get: function get() {
    return _ic_menu.default;
  }
});
Object.defineProperty(exports, "ic_merge__call", {
  enumerable: true,
  get: function get() {
    return _ic_merge__call.default;
  }
});
Object.defineProperty(exports, "ic_mesh__wifi__and__repeater", {
  enumerable: true,
  get: function get() {
    return _ic_mesh__wifi__and__repeater.default;
  }
});
Object.defineProperty(exports, "ic_message", {
  enumerable: true,
  get: function get() {
    return _ic_message.default;
  }
});
Object.defineProperty(exports, "ic_microphone", {
  enumerable: true,
  get: function get() {
    return _ic_microphone.default;
  }
});
Object.defineProperty(exports, "ic_minimize__image", {
  enumerable: true,
  get: function get() {
    return _ic_minimize__image.default;
  }
});
Object.defineProperty(exports, "ic_minus__or__less", {
  enumerable: true,
  get: function get() {
    return _ic_minus__or__less.default;
  }
});
Object.defineProperty(exports, "ic_minutes__sms", {
  enumerable: true,
  get: function get() {
    return _ic_minutes__sms.default;
  }
});
Object.defineProperty(exports, "ic_mobile__broadband", {
  enumerable: true,
  get: function get() {
    return _ic_mobile__broadband.default;
  }
});
Object.defineProperty(exports, "ic_mobile__signal__strength__excellent", {
  enumerable: true,
  get: function get() {
    return _ic_mobile__signal__strength__excellent.default;
  }
});
Object.defineProperty(exports, "ic_mobile__signal__strength__good", {
  enumerable: true,
  get: function get() {
    return _ic_mobile__signal__strength__good.default;
  }
});
Object.defineProperty(exports, "ic_mobile__signal__strength__marginal", {
  enumerable: true,
  get: function get() {
    return _ic_mobile__signal__strength__marginal.default;
  }
});
Object.defineProperty(exports, "ic_mobile__signal__strength__no__signal", {
  enumerable: true,
  get: function get() {
    return _ic_mobile__signal__strength__no__signal.default;
  }
});
Object.defineProperty(exports, "ic_mobile__signal__strength__ok", {
  enumerable: true,
  get: function get() {
    return _ic_mobile__signal__strength__ok.default;
  }
});
Object.defineProperty(exports, "ic_mobile", {
  enumerable: true,
  get: function get() {
    return _ic_mobile.default;
  }
});
Object.defineProperty(exports, "ic_monitor__brightness__contrast", {
  enumerable: true,
  get: function get() {
    return _ic_monitor__brightness__contrast.default;
  }
});
Object.defineProperty(exports, "ic_more__android", {
  enumerable: true,
  get: function get() {
    return _ic_more__android.default;
  }
});
Object.defineProperty(exports, "ic_more", {
  enumerable: true,
  get: function get() {
    return _ic_more.default;
  }
});
Object.defineProperty(exports, "ic_motion__alert", {
  enumerable: true,
  get: function get() {
    return _ic_motion__alert.default;
  }
});
Object.defineProperty(exports, "ic_motion__sensor", {
  enumerable: true,
  get: function get() {
    return _ic_motion__sensor.default;
  }
});
Object.defineProperty(exports, "ic_motion", {
  enumerable: true,
  get: function get() {
    return _ic_motion.default;
  }
});
Object.defineProperty(exports, "ic_multiscreen", {
  enumerable: true,
  get: function get() {
    return _ic_multiscreen.default;
  }
});
Object.defineProperty(exports, "ic_music__and__movies", {
  enumerable: true,
  get: function get() {
    return _ic_music__and__movies.default;
  }
});
Object.defineProperty(exports, "ic_mute", {
  enumerable: true,
  get: function get() {
    return _ic_mute.default;
  }
});
Object.defineProperty(exports, "ic_my__trips", {
  enumerable: true,
  get: function get() {
    return _ic_my__trips.default;
  }
});
Object.defineProperty(exports, "ic_my__vodafone__or__profile", {
  enumerable: true,
  get: function get() {
    return _ic_my__vodafone__or__profile.default;
  }
});
Object.defineProperty(exports, "ic_my__vodafone", {
  enumerable: true,
  get: function get() {
    return _ic_my__vodafone.default;
  }
});
Object.defineProperty(exports, "ic_need__help", {
  enumerable: true,
  get: function get() {
    return _ic_need__help.default;
  }
});
Object.defineProperty(exports, "ic_network__patch__panel", {
  enumerable: true,
  get: function get() {
    return _ic_network__patch__panel.default;
  }
});
Object.defineProperty(exports, "ic_network__signal", {
  enumerable: true,
  get: function get() {
    return _ic_network__signal.default;
  }
});
Object.defineProperty(exports, "ic_network", {
  enumerable: true,
  get: function get() {
    return _ic_network.default;
  }
});
Object.defineProperty(exports, "ic_newest__tech", {
  enumerable: true,
  get: function get() {
    return _ic_newest__tech.default;
  }
});
Object.defineProperty(exports, "ic_news", {
  enumerable: true,
  get: function get() {
    return _ic_news.default;
  }
});
Object.defineProperty(exports, "ic_night__vision", {
  enumerable: true,
  get: function get() {
    return _ic_night__vision.default;
  }
});
Object.defineProperty(exports, "ic_no__wifi", {
  enumerable: true,
  get: function get() {
    return _ic_no__wifi.default;
  }
});
Object.defineProperty(exports, "ic_notification__muted", {
  enumerable: true,
  get: function get() {
    return _ic_notification__muted.default;
  }
});
Object.defineProperty(exports, "ic_notification", {
  enumerable: true,
  get: function get() {
    return _ic_notification.default;
  }
});
Object.defineProperty(exports, "ic_number__0", {
  enumerable: true,
  get: function get() {
    return _ic_number__.default;
  }
});
Object.defineProperty(exports, "ic_number__1", {
  enumerable: true,
  get: function get() {
    return _ic_number__2.default;
  }
});
Object.defineProperty(exports, "ic_number__2", {
  enumerable: true,
  get: function get() {
    return _ic_number__3.default;
  }
});
Object.defineProperty(exports, "ic_number__3", {
  enumerable: true,
  get: function get() {
    return _ic_number__4.default;
  }
});
Object.defineProperty(exports, "ic_number__4", {
  enumerable: true,
  get: function get() {
    return _ic_number__5.default;
  }
});
Object.defineProperty(exports, "ic_number__5", {
  enumerable: true,
  get: function get() {
    return _ic_number__6.default;
  }
});
Object.defineProperty(exports, "ic_number__6", {
  enumerable: true,
  get: function get() {
    return _ic_number__7.default;
  }
});
Object.defineProperty(exports, "ic_number__7", {
  enumerable: true,
  get: function get() {
    return _ic_number__8.default;
  }
});
Object.defineProperty(exports, "ic_number__8", {
  enumerable: true,
  get: function get() {
    return _ic_number__9.default;
  }
});
Object.defineProperty(exports, "ic_number__9", {
  enumerable: true,
  get: function get() {
    return _ic_number__10.default;
  }
});
Object.defineProperty(exports, "ic_number__portability", {
  enumerable: true,
  get: function get() {
    return _ic_number__portability.default;
  }
});
Object.defineProperty(exports, "ic_numbered__view", {
  enumerable: true,
  get: function get() {
    return _ic_numbered__view.default;
  }
});
Object.defineProperty(exports, "ic_offer__badge__percent", {
  enumerable: true,
  get: function get() {
    return _ic_offer__badge__percent.default;
  }
});
Object.defineProperty(exports, "ic_offer__badge", {
  enumerable: true,
  get: function get() {
    return _ic_offer__badge.default;
  }
});
Object.defineProperty(exports, "ic_online__offers", {
  enumerable: true,
  get: function get() {
    return _ic_online__offers.default;
  }
});
Object.defineProperty(exports, "ic_online", {
  enumerable: true,
  get: function get() {
    return _ic_online.default;
  }
});
Object.defineProperty(exports, "ic_open__24__7", {
  enumerable: true,
  get: function get() {
    return _ic_open__24__.default;
  }
});
Object.defineProperty(exports, "ic_optical__network__port", {
  enumerable: true,
  get: function get() {
    return _ic_optical__network__port.default;
  }
});
Object.defineProperty(exports, "ic_outgoing__call", {
  enumerable: true,
  get: function get() {
    return _ic_outgoing__call.default;
  }
});
Object.defineProperty(exports, "ic_padlock__close", {
  enumerable: true,
  get: function get() {
    return _ic_padlock__close.default;
  }
});
Object.defineProperty(exports, "ic_padlock__open", {
  enumerable: true,
  get: function get() {
    return _ic_padlock__open.default;
  }
});
Object.defineProperty(exports, "ic_parental__control", {
  enumerable: true,
  get: function get() {
    return _ic_parental__control.default;
  }
});
Object.defineProperty(exports, "ic_parking__ticket", {
  enumerable: true,
  get: function get() {
    return _ic_parking__ticket.default;
  }
});
Object.defineProperty(exports, "ic_password__key", {
  enumerable: true,
  get: function get() {
    return _ic_password__key.default;
  }
});
Object.defineProperty(exports, "ic_pause__circle", {
  enumerable: true,
  get: function get() {
    return _ic_pause__circle.default;
  }
});
Object.defineProperty(exports, "ic_pause", {
  enumerable: true,
  get: function get() {
    return _ic_pause.default;
  }
});
Object.defineProperty(exports, "ic_payg", {
  enumerable: true,
  get: function get() {
    return _ic_payg.default;
  }
});
Object.defineProperty(exports, "ic_payment", {
  enumerable: true,
  get: function get() {
    return _ic_payment.default;
  }
});
Object.defineProperty(exports, "ic_paypal", {
  enumerable: true,
  get: function get() {
    return _ic_paypal.default;
  }
});
Object.defineProperty(exports, "ic_pet__collar", {
  enumerable: true,
  get: function get() {
    return _ic_pet__collar.default;
  }
});
Object.defineProperty(exports, "ic_photos", {
  enumerable: true,
  get: function get() {
    return _ic_photos.default;
  }
});
Object.defineProperty(exports, "ic_pie__chart", {
  enumerable: true,
  get: function get() {
    return _ic_pie__chart.default;
  }
});
Object.defineProperty(exports, "ic_ping", {
  enumerable: true,
  get: function get() {
    return _ic_ping.default;
  }
});
Object.defineProperty(exports, "ic_play__arrow", {
  enumerable: true,
  get: function get() {
    return _ic_play__arrow.default;
  }
});
Object.defineProperty(exports, "ic_play__circle", {
  enumerable: true,
  get: function get() {
    return _ic_play__circle.default;
  }
});
Object.defineProperty(exports, "ic_play__store", {
  enumerable: true,
  get: function get() {
    return _ic_play__store.default;
  }
});
Object.defineProperty(exports, "ic_play", {
  enumerable: true,
  get: function get() {
    return _ic_play.default;
  }
});
Object.defineProperty(exports, "ic_plus", {
  enumerable: true,
  get: function get() {
    return _ic_plus.default;
  }
});
Object.defineProperty(exports, "ic_pop__in", {
  enumerable: true,
  get: function get() {
    return _ic_pop__in.default;
  }
});
Object.defineProperty(exports, "ic_pop__out", {
  enumerable: true,
  get: function get() {
    return _ic_pop__out.default;
  }
});
Object.defineProperty(exports, "ic_power", {
  enumerable: true,
  get: function get() {
    return _ic_power.default;
  }
});
Object.defineProperty(exports, "ic_prepare", {
  enumerable: true,
  get: function get() {
    return _ic_prepare.default;
  }
});
Object.defineProperty(exports, "ic_price__promise", {
  enumerable: true,
  get: function get() {
    return _ic_price__promise.default;
  }
});
Object.defineProperty(exports, "ic_price__tag", {
  enumerable: true,
  get: function get() {
    return _ic_price__tag.default;
  }
});
Object.defineProperty(exports, "ic_print", {
  enumerable: true,
  get: function get() {
    return _ic_print.default;
  }
});
Object.defineProperty(exports, "ic_privacy__confidential", {
  enumerable: true,
  get: function get() {
    return _ic_privacy__confidential.default;
  }
});
Object.defineProperty(exports, "ic_privacy__or__confidential", {
  enumerable: true,
  get: function get() {
    return _ic_privacy__or__confidential.default;
  }
});
Object.defineProperty(exports, "ic_privacy", {
  enumerable: true,
  get: function get() {
    return _ic_privacy.default;
  }
});
Object.defineProperty(exports, "ic_profile", {
  enumerable: true,
  get: function get() {
    return _ic_profile.default;
  }
});
Object.defineProperty(exports, "ic_public__sector", {
  enumerable: true,
  get: function get() {
    return _ic_public__sector.default;
  }
});
Object.defineProperty(exports, "ic_public__wifi", {
  enumerable: true,
  get: function get() {
    return _ic_public__wifi.default;
  }
});
Object.defineProperty(exports, "ic_qr__code", {
  enumerable: true,
  get: function get() {
    return _ic_qr__code.default;
  }
});
Object.defineProperty(exports, "ic_raffles", {
  enumerable: true,
  get: function get() {
    return _ic_raffles.default;
  }
});
Object.defineProperty(exports, "ic_rank__ace", {
  enumerable: true,
  get: function get() {
    return _ic_rank__ace.default;
  }
});
Object.defineProperty(exports, "ic_rank__badge__title", {
  enumerable: true,
  get: function get() {
    return _ic_rank__badge__title.default;
  }
});
Object.defineProperty(exports, "ic_rank__genius", {
  enumerable: true,
  get: function get() {
    return _ic_rank__genius.default;
  }
});
Object.defineProperty(exports, "ic_rank__guru", {
  enumerable: true,
  get: function get() {
    return _ic_rank__guru.default;
  }
});
Object.defineProperty(exports, "ic_rank__master", {
  enumerable: true,
  get: function get() {
    return _ic_rank__master.default;
  }
});
Object.defineProperty(exports, "ic_rank__networker", {
  enumerable: true,
  get: function get() {
    return _ic_rank__networker.default;
  }
});
Object.defineProperty(exports, "ic_rank__pioneer", {
  enumerable: true,
  get: function get() {
    return _ic_rank__pioneer.default;
  }
});
Object.defineProperty(exports, "ic_rank__pro", {
  enumerable: true,
  get: function get() {
    return _ic_rank__pro.default;
  }
});
Object.defineProperty(exports, "ic_rank__professor", {
  enumerable: true,
  get: function get() {
    return _ic_rank__professor.default;
  }
});
Object.defineProperty(exports, "ic_rank__savvy", {
  enumerable: true,
  get: function get() {
    return _ic_rank__savvy.default;
  }
});
Object.defineProperty(exports, "ic_rank__scout", {
  enumerable: true,
  get: function get() {
    return _ic_rank__scout.default;
  }
});
Object.defineProperty(exports, "ic_rank__virtuoso", {
  enumerable: true,
  get: function get() {
    return _ic_rank__virtuoso.default;
  }
});
Object.defineProperty(exports, "ic_rank__wizard", {
  enumerable: true,
  get: function get() {
    return _ic_rank__wizard.default;
  }
});
Object.defineProperty(exports, "ic_rank__writer", {
  enumerable: true,
  get: function get() {
    return _ic_rank__writer.default;
  }
});
Object.defineProperty(exports, "ic_rating__0", {
  enumerable: true,
  get: function get() {
    return _ic_rating__.default;
  }
});
Object.defineProperty(exports, "ic_rating__5", {
  enumerable: true,
  get: function get() {
    return _ic_rating__2.default;
  }
});
Object.defineProperty(exports, "ic_ratings__or__favourite", {
  enumerable: true,
  get: function get() {
    return _ic_ratings__or__favourite.default;
  }
});
Object.defineProperty(exports, "ic_ratings", {
  enumerable: true,
  get: function get() {
    return _ic_ratings.default;
  }
});
Object.defineProperty(exports, "ic_rearrange", {
  enumerable: true,
  get: function get() {
    return _ic_rearrange.default;
  }
});
Object.defineProperty(exports, "ic_recommend__drafts", {
  enumerable: true,
  get: function get() {
    return _ic_recommend__drafts.default;
  }
});
Object.defineProperty(exports, "ic_recommendation", {
  enumerable: true,
  get: function get() {
    return _ic_recommendation.default;
  }
});
Object.defineProperty(exports, "ic_redeemed__unlocked__rewards", {
  enumerable: true,
  get: function get() {
    return _ic_redeemed__unlocked__rewards.default;
  }
});
Object.defineProperty(exports, "ic_refresh", {
  enumerable: true,
  get: function get() {
    return _ic_refresh.default;
  }
});
Object.defineProperty(exports, "ic_reply", {
  enumerable: true,
  get: function get() {
    return _ic_reply.default;
  }
});
Object.defineProperty(exports, "ic_report", {
  enumerable: true,
  get: function get() {
    return _ic_report.default;
  }
});
Object.defineProperty(exports, "ic_reports", {
  enumerable: true,
  get: function get() {
    return _ic_reports.default;
  }
});
Object.defineProperty(exports, "ic_return__product", {
  enumerable: true,
  get: function get() {
    return _ic_return__product.default;
  }
});
Object.defineProperty(exports, "ic_roaming", {
  enumerable: true,
  get: function get() {
    return _ic_roaming.default;
  }
});
Object.defineProperty(exports, "ic_router", {
  enumerable: true,
  get: function get() {
    return _ic_router.default;
  }
});
Object.defineProperty(exports, "ic_safe__zone", {
  enumerable: true,
  get: function get() {
    return _ic_safe__zone.default;
  }
});
Object.defineProperty(exports, "ic_save", {
  enumerable: true,
  get: function get() {
    return _ic_save.default;
  }
});
Object.defineProperty(exports, "ic_saving", {
  enumerable: true,
  get: function get() {
    return _ic_saving.default;
  }
});
Object.defineProperty(exports, "ic_screen__repair", {
  enumerable: true,
  get: function get() {
    return _ic_screen__repair.default;
  }
});
Object.defineProperty(exports, "ic_screen__size", {
  enumerable: true,
  get: function get() {
    return _ic_screen__size.default;
  }
});
Object.defineProperty(exports, "ic_search", {
  enumerable: true,
  get: function get() {
    return _ic_search.default;
  }
});
Object.defineProperty(exports, "ic_secure__grip", {
  enumerable: true,
  get: function get() {
    return _ic_secure__grip.default;
  }
});
Object.defineProperty(exports, "ic_security__camera", {
  enumerable: true,
  get: function get() {
    return _ic_security__camera.default;
  }
});
Object.defineProperty(exports, "ic_security", {
  enumerable: true,
  get: function get() {
    return _ic_security.default;
  }
});
Object.defineProperty(exports, "ic_send__tobi", {
  enumerable: true,
  get: function get() {
    return _ic_send__tobi.default;
  }
});
Object.defineProperty(exports, "ic_senior", {
  enumerable: true,
  get: function get() {
    return _ic_senior.default;
  }
});
Object.defineProperty(exports, "ic_settings", {
  enumerable: true,
  get: function get() {
    return _ic_settings.default;
  }
});
Object.defineProperty(exports, "ic_setup", {
  enumerable: true,
  get: function get() {
    return _ic_setup.default;
  }
});
Object.defineProperty(exports, "ic_shake", {
  enumerable: true,
  get: function get() {
    return _ic_shake.default;
  }
});
Object.defineProperty(exports, "ic_share__your__mins", {
  enumerable: true,
  get: function get() {
    return _ic_share__your__mins.default;
  }
});
Object.defineProperty(exports, "ic_share", {
  enumerable: true,
  get: function get() {
    return _ic_share.default;
  }
});
Object.defineProperty(exports, "ic_shopping__checkout", {
  enumerable: true,
  get: function get() {
    return _ic_shopping__checkout.default;
  }
});
Object.defineProperty(exports, "ic_shopping__trolley", {
  enumerable: true,
  get: function get() {
    return _ic_shopping__trolley.default;
  }
});
Object.defineProperty(exports, "ic_shopping", {
  enumerable: true,
  get: function get() {
    return _ic_shopping.default;
  }
});
Object.defineProperty(exports, "ic_signed__in", {
  enumerable: true,
  get: function get() {
    return _ic_signed__in.default;
  }
});
Object.defineProperty(exports, "ic_sim__single", {
  enumerable: true,
  get: function get() {
    return _ic_sim__single.default;
  }
});
Object.defineProperty(exports, "ic_sim__swap", {
  enumerable: true,
  get: function get() {
    return _ic_sim__swap.default;
  }
});
Object.defineProperty(exports, "ic_sim", {
  enumerable: true,
  get: function get() {
    return _ic_sim.default;
  }
});
Object.defineProperty(exports, "ic_single__pallet", {
  enumerable: true,
  get: function get() {
    return _ic_single__pallet.default;
  }
});
Object.defineProperty(exports, "ic_small__and__lightweight", {
  enumerable: true,
  get: function get() {
    return _ic_small__and__lightweight.default;
  }
});
Object.defineProperty(exports, "ic_smart__plug", {
  enumerable: true,
  get: function get() {
    return _ic_smart__plug.default;
  }
});
Object.defineProperty(exports, "ic_smarthome__kit", {
  enumerable: true,
  get: function get() {
    return _ic_smarthome__kit.default;
  }
});
Object.defineProperty(exports, "ic_sme", {
  enumerable: true,
  get: function get() {
    return _ic_sme.default;
  }
});
Object.defineProperty(exports, "ic_smiley", {
  enumerable: true,
  get: function get() {
    return _ic_smiley.default;
  }
});
Object.defineProperty(exports, "ic_sms", {
  enumerable: true,
  get: function get() {
    return _ic_sms.default;
  }
});
Object.defineProperty(exports, "ic_social__chat", {
  enumerable: true,
  get: function get() {
    return _ic_social__chat.default;
  }
});
Object.defineProperty(exports, "ic_social__facebook", {
  enumerable: true,
  get: function get() {
    return _ic_social__facebook.default;
  }
});
Object.defineProperty(exports, "ic_social__google__plus", {
  enumerable: true,
  get: function get() {
    return _ic_social__google__plus.default;
  }
});
Object.defineProperty(exports, "ic_social__instagram", {
  enumerable: true,
  get: function get() {
    return _ic_social__instagram.default;
  }
});
Object.defineProperty(exports, "ic_social__linkedin", {
  enumerable: true,
  get: function get() {
    return _ic_social__linkedin.default;
  }
});
Object.defineProperty(exports, "ic_social__paypal", {
  enumerable: true,
  get: function get() {
    return _ic_social__paypal.default;
  }
});
Object.defineProperty(exports, "ic_social__pinterest", {
  enumerable: true,
  get: function get() {
    return _ic_social__pinterest.default;
  }
});
Object.defineProperty(exports, "ic_social__twitter", {
  enumerable: true,
  get: function get() {
    return _ic_social__twitter.default;
  }
});
Object.defineProperty(exports, "ic_social__whatsapp", {
  enumerable: true,
  get: function get() {
    return _ic_social__whatsapp.default;
  }
});
Object.defineProperty(exports, "ic_social__youtube", {
  enumerable: true,
  get: function get() {
    return _ic_social__youtube.default;
  }
});
Object.defineProperty(exports, "ic_soho", {
  enumerable: true,
  get: function get() {
    return _ic_soho.default;
  }
});
Object.defineProperty(exports, "ic_solution__finder", {
  enumerable: true,
  get: function get() {
    return _ic_solution__finder.default;
  }
});
Object.defineProperty(exports, "ic_sort", {
  enumerable: true,
  get: function get() {
    return _ic_sort.default;
  }
});
Object.defineProperty(exports, "ic_sos__credit__topup", {
  enumerable: true,
  get: function get() {
    return _ic_sos__credit__topup.default;
  }
});
Object.defineProperty(exports, "ic_sos__credit", {
  enumerable: true,
  get: function get() {
    return _ic_sos__credit.default;
  }
});
Object.defineProperty(exports, "ic_sos__emergency", {
  enumerable: true,
  get: function get() {
    return _ic_sos__emergency.default;
  }
});
Object.defineProperty(exports, "ic_sound__active", {
  enumerable: true,
  get: function get() {
    return _ic_sound__active.default;
  }
});
Object.defineProperty(exports, "ic_sound__off", {
  enumerable: true,
  get: function get() {
    return _ic_sound__off.default;
  }
});
Object.defineProperty(exports, "ic_sound", {
  enumerable: true,
  get: function get() {
    return _ic_sound.default;
  }
});
Object.defineProperty(exports, "ic_speeding", {
  enumerable: true,
  get: function get() {
    return _ic_speeding.default;
  }
});
Object.defineProperty(exports, "ic_spell__check", {
  enumerable: true,
  get: function get() {
    return _ic_spell__check.default;
  }
});
Object.defineProperty(exports, "ic_spinner", {
  enumerable: true,
  get: function get() {
    return _ic_spinner.default;
  }
});
Object.defineProperty(exports, "ic_steering__wheel", {
  enumerable: true,
  get: function get() {
    return _ic_steering__wheel.default;
  }
});
Object.defineProperty(exports, "ic_stop__circle", {
  enumerable: true,
  get: function get() {
    return _ic_stop__circle.default;
  }
});
Object.defineProperty(exports, "ic_stop", {
  enumerable: true,
  get: function get() {
    return _ic_stop.default;
  }
});
Object.defineProperty(exports, "ic_storage", {
  enumerable: true,
  get: function get() {
    return _ic_storage.default;
  }
});
Object.defineProperty(exports, "ic_store__offers", {
  enumerable: true,
  get: function get() {
    return _ic_store__offers.default;
  }
});
Object.defineProperty(exports, "ic_strike__through", {
  enumerable: true,
  get: function get() {
    return _ic_strike__through.default;
  }
});
Object.defineProperty(exports, "ic_student", {
  enumerable: true,
  get: function get() {
    return _ic_student.default;
  }
});
Object.defineProperty(exports, "ic_superstar", {
  enumerable: true,
  get: function get() {
    return _ic_superstar.default;
  }
});
Object.defineProperty(exports, "ic_support", {
  enumerable: true,
  get: function get() {
    return _ic_support.default;
  }
});
Object.defineProperty(exports, "ic_surveillance__camera", {
  enumerable: true,
  get: function get() {
    return _ic_surveillance__camera.default;
  }
});
Object.defineProperty(exports, "ic_switch__call", {
  enumerable: true,
  get: function get() {
    return _ic_switch__call.default;
  }
});
Object.defineProperty(exports, "ic_sync", {
  enumerable: true,
  get: function get() {
    return _ic_sync.default;
  }
});
Object.defineProperty(exports, "ic_tablet", {
  enumerable: true,
  get: function get() {
    return _ic_tablet.default;
  }
});
Object.defineProperty(exports, "ic_tail", {
  enumerable: true,
  get: function get() {
    return _ic_tail.default;
  }
});
Object.defineProperty(exports, "ic_tethering", {
  enumerable: true,
  get: function get() {
    return _ic_tethering.default;
  }
});
Object.defineProperty(exports, "ic_text", {
  enumerable: true,
  get: function get() {
    return _ic_text.default;
  }
});
Object.defineProperty(exports, "ic_tick__or__solved", {
  enumerable: true,
  get: function get() {
    return _ic_tick__or__solved.default;
  }
});
Object.defineProperty(exports, "ic_tick__outline", {
  enumerable: true,
  get: function get() {
    return _ic_tick__outline.default;
  }
});
Object.defineProperty(exports, "ic_tick", {
  enumerable: true,
  get: function get() {
    return _ic_tick.default;
  }
});
Object.defineProperty(exports, "ic_top__up", {
  enumerable: true,
  get: function get() {
    return _ic_top__up.default;
  }
});
Object.defineProperty(exports, "ic_topics", {
  enumerable: true,
  get: function get() {
    return _ic_topics.default;
  }
});
Object.defineProperty(exports, "ic_touch__screen", {
  enumerable: true,
  get: function get() {
    return _ic_touch__screen.default;
  }
});
Object.defineProperty(exports, "ic_tracker", {
  enumerable: true,
  get: function get() {
    return _ic_tracker.default;
  }
});
Object.defineProperty(exports, "ic_trackisafe", {
  enumerable: true,
  get: function get() {
    return _ic_trackisafe.default;
  }
});
Object.defineProperty(exports, "ic_translate", {
  enumerable: true,
  get: function get() {
    return _ic_translate.default;
  }
});
Object.defineProperty(exports, "ic_tutorials", {
  enumerable: true,
  get: function get() {
    return _ic_tutorials.default;
  }
});
Object.defineProperty(exports, "ic_tv__anytime", {
  enumerable: true,
  get: function get() {
    return _ic_tv__anytime.default;
  }
});
Object.defineProperty(exports, "ic_tv__bluetooth__remote__a", {
  enumerable: true,
  get: function get() {
    return _ic_tv__bluetooth__remote__a.default;
  }
});
Object.defineProperty(exports, "ic_tv__bluetooth__remote__b", {
  enumerable: true,
  get: function get() {
    return _ic_tv__bluetooth__remote__b.default;
  }
});
Object.defineProperty(exports, "ic_tv__channel__management", {
  enumerable: true,
  get: function get() {
    return _ic_tv__channel__management.default;
  }
});
Object.defineProperty(exports, "ic_tv__channel__variety", {
  enumerable: true,
  get: function get() {
    return _ic_tv__channel__variety.default;
  }
});
Object.defineProperty(exports, "ic_tv__cloud__dvr", {
  enumerable: true,
  get: function get() {
    return _ic_tv__cloud__dvr.default;
  }
});
Object.defineProperty(exports, "ic_tv__discovery", {
  enumerable: true,
  get: function get() {
    return _ic_tv__discovery.default;
  }
});
Object.defineProperty(exports, "ic_tv__epg__backwards", {
  enumerable: true,
  get: function get() {
    return _ic_tv__epg__backwards.default;
  }
});
Object.defineProperty(exports, "ic_tv__epg", {
  enumerable: true,
  get: function get() {
    return _ic_tv__epg.default;
  }
});
Object.defineProperty(exports, "ic_tv__everywhere__home", {
  enumerable: true,
  get: function get() {
    return _ic_tv__everywhere__home.default;
  }
});
Object.defineProperty(exports, "ic_tv__everywhere", {
  enumerable: true,
  get: function get() {
    return _ic_tv__everywhere.default;
  }
});
Object.defineProperty(exports, "ic_tv__for__you", {
  enumerable: true,
  get: function get() {
    return _ic_tv__for__you.default;
  }
});
Object.defineProperty(exports, "ic_tv__hd", {
  enumerable: true,
  get: function get() {
    return _ic_tv__hd.default;
  }
});
Object.defineProperty(exports, "ic_tv__kids", {
  enumerable: true,
  get: function get() {
    return _ic_tv__kids.default;
  }
});
Object.defineProperty(exports, "ic_tv__mediatheken", {
  enumerable: true,
  get: function get() {
    return _ic_tv__mediatheken.default;
  }
});
Object.defineProperty(exports, "ic_tv__multiscreen", {
  enumerable: true,
  get: function get() {
    return _ic_tv__multiscreen.default;
  }
});
Object.defineProperty(exports, "ic_tv__primetime", {
  enumerable: true,
  get: function get() {
    return _ic_tv__primetime.default;
  }
});
Object.defineProperty(exports, "ic_tv__remote", {
  enumerable: true,
  get: function get() {
    return _ic_tv__remote.default;
  }
});
Object.defineProperty(exports, "ic_tv__restart", {
  enumerable: true,
  get: function get() {
    return _ic_tv__restart.default;
  }
});
Object.defineProperty(exports, "ic_tv__storage", {
  enumerable: true,
  get: function get() {
    return _ic_tv__storage.default;
  }
});
Object.defineProperty(exports, "ic_tv__time__flexible", {
  enumerable: true,
  get: function get() {
    return _ic_tv__time__flexible.default;
  }
});
Object.defineProperty(exports, "ic_tv__tv", {
  enumerable: true,
  get: function get() {
    return _ic_tv__tv.default;
  }
});
Object.defineProperty(exports, "ic_tv__uhd", {
  enumerable: true,
  get: function get() {
    return _ic_tv__uhd.default;
  }
});
Object.defineProperty(exports, "ic_tv__videostore", {
  enumerable: true,
  get: function get() {
    return _ic_tv__videostore.default;
  }
});
Object.defineProperty(exports, "ic_tv__vod", {
  enumerable: true,
  get: function get() {
    return _ic_tv__vod.default;
  }
});
Object.defineProperty(exports, "ic_tv", {
  enumerable: true,
  get: function get() {
    return _ic_tv.default;
  }
});
Object.defineProperty(exports, "ic_underlined", {
  enumerable: true,
  get: function get() {
    return _ic_underlined.default;
  }
});
Object.defineProperty(exports, "ic_unified__communication", {
  enumerable: true,
  get: function get() {
    return _ic_unified__communication.default;
  }
});
Object.defineProperty(exports, "ic_unlimited", {
  enumerable: true,
  get: function get() {
    return _ic_unlimited.default;
  }
});
Object.defineProperty(exports, "ic_unlock__reward", {
  enumerable: true,
  get: function get() {
    return _ic_unlock__reward.default;
  }
});
Object.defineProperty(exports, "ic_upgrade", {
  enumerable: true,
  get: function get() {
    return _ic_upgrade.default;
  }
});
Object.defineProperty(exports, "ic_upload__cloud", {
  enumerable: true,
  get: function get() {
    return _ic_upload__cloud.default;
  }
});
Object.defineProperty(exports, "ic_upload", {
  enumerable: true,
  get: function get() {
    return _ic_upload.default;
  }
});
Object.defineProperty(exports, "ic_usb", {
  enumerable: true,
  get: function get() {
    return _ic_usb.default;
  }
});
Object.defineProperty(exports, "ic_usb_modem", {
  enumerable: true,
  get: function get() {
    return _ic_usb_modem.default;
  }
});
Object.defineProperty(exports, "ic_user__log__in", {
  enumerable: true,
  get: function get() {
    return _ic_user__log__in.default;
  }
});
Object.defineProperty(exports, "ic_users", {
  enumerable: true,
  get: function get() {
    return _ic_users.default;
  }
});
Object.defineProperty(exports, "ic_v__baby", {
  enumerable: true,
  get: function get() {
    return _ic_v__baby.default;
  }
});
Object.defineProperty(exports, "ic_v__bag", {
  enumerable: true,
  get: function get() {
    return _ic_v__bag.default;
  }
});
Object.defineProperty(exports, "ic_v__car__dongle", {
  enumerable: true,
  get: function get() {
    return _ic_v__car__dongle.default;
  }
});
Object.defineProperty(exports, "ic_v__home__monitor", {
  enumerable: true,
  get: function get() {
    return _ic_v__home__monitor.default;
  }
});
Object.defineProperty(exports, "ic_v__kids", {
  enumerable: true,
  get: function get() {
    return _ic_v__kids.default;
  }
});
Object.defineProperty(exports, "ic_v__pet", {
  enumerable: true,
  get: function get() {
    return _ic_v__pet.default;
  }
});
Object.defineProperty(exports, "ic_v__sim__and__device", {
  enumerable: true,
  get: function get() {
    return _ic_v__sim__and__device.default;
  }
});
Object.defineProperty(exports, "ic_v__sim__andice", {
  enumerable: true,
  get: function get() {
    return _ic_v__sim__andice.default;
  }
});
Object.defineProperty(exports, "ic_video__cloud", {
  enumerable: true,
  get: function get() {
    return _ic_video__cloud.default;
  }
});
Object.defineProperty(exports, "ic_video", {
  enumerable: true,
  get: function get() {
    return _ic_video.default;
  }
});
Object.defineProperty(exports, "ic_viewed", {
  enumerable: true,
  get: function get() {
    return _ic_viewed.default;
  }
});
Object.defineProperty(exports, "ic_virtual__device", {
  enumerable: true,
  get: function get() {
    return _ic_virtual__device.default;
  }
});
Object.defineProperty(exports, "ic_virtualice", {
  enumerable: true,
  get: function get() {
    return _ic_virtualice.default;
  }
});
Object.defineProperty(exports, "ic_virus__protection", {
  enumerable: true,
  get: function get() {
    return _ic_virus__protection.default;
  }
});
Object.defineProperty(exports, "ic_vodafone__logo__white", {
  enumerable: true,
  get: function get() {
    return _ic_vodafone__logo__white.default;
  }
});
Object.defineProperty(exports, "ic_vodafone__logo", {
  enumerable: true,
  get: function get() {
    return _ic_vodafone__logo.default;
  }
});
Object.defineProperty(exports, "ic_vodafone__store", {
  enumerable: true,
  get: function get() {
    return _ic_vodafone__store.default;
  }
});
Object.defineProperty(exports, "ic_vodafone", {
  enumerable: true,
  get: function get() {
    return _ic_vodafone.default;
  }
});
Object.defineProperty(exports, "ic_voice__of__vodafone__alerts", {
  enumerable: true,
  get: function get() {
    return _ic_voice__of__vodafone__alerts.default;
  }
});
Object.defineProperty(exports, "ic_voicemail", {
  enumerable: true,
  get: function get() {
    return _ic_voicemail.default;
  }
});
Object.defineProperty(exports, "ic_warning", {
  enumerable: true,
  get: function get() {
    return _ic_warning.default;
  }
});
Object.defineProperty(exports, "ic_watch", {
  enumerable: true,
  get: function get() {
    return _ic_watch.default;
  }
});
Object.defineProperty(exports, "ic_waterproof", {
  enumerable: true,
  get: function get() {
    return _ic_waterproof.default;
  }
});
Object.defineProperty(exports, "ic_web__protection", {
  enumerable: true,
  get: function get() {
    return _ic_web__protection.default;
  }
});
Object.defineProperty(exports, "ic_webcamera", {
  enumerable: true,
  get: function get() {
    return _ic_webcamera.default;
  }
});
Object.defineProperty(exports, "ic_website", {
  enumerable: true,
  get: function get() {
    return _ic_website.default;
  }
});
Object.defineProperty(exports, "ic_weight", {
  enumerable: true,
  get: function get() {
    return _ic_weight.default;
  }
});
Object.defineProperty(exports, "ic_white__paper", {
  enumerable: true,
  get: function get() {
    return _ic_white__paper.default;
  }
});
Object.defineProperty(exports, "ic_wifi__good", {
  enumerable: true,
  get: function get() {
    return _ic_wifi__good.default;
  }
});
Object.defineProperty(exports, "ic_wifi__medium", {
  enumerable: true,
  get: function get() {
    return _ic_wifi__medium.default;
  }
});
Object.defineProperty(exports, "ic_wifi__poor", {
  enumerable: true,
  get: function get() {
    return _ic_wifi__poor.default;
  }
});
Object.defineProperty(exports, "ic_wiring__connections", {
  enumerable: true,
  get: function get() {
    return _ic_wiring__connections.default;
  }
});
Object.defineProperty(exports, "ic_world", {
  enumerable: true,
  get: function get() {
    return _ic_world.default;
  }
});
Object.defineProperty(exports, "ic_writer", {
  enumerable: true,
  get: function get() {
    return _ic_writer.default;
  }
});
Object.defineProperty(exports, "ic_zoom__in", {
  enumerable: true,
  get: function get() {
    return _ic_zoom__in.default;
  }
});
Object.defineProperty(exports, "ic_zoom__out", {
  enumerable: true,
  get: function get() {
    return _ic_zoom__out.default;
  }
});

var _ic_24__7__support = _interopRequireDefault(require("./ic_24__7__support"));

var _ic_2g = _interopRequireDefault(require("./ic_2g"));

var _ic_360__degrees = _interopRequireDefault(require("./ic_360__degrees"));

var _ic_360__view = _interopRequireDefault(require("./ic_360__view"));

var _ic_3g = _interopRequireDefault(require("./ic_3g"));

var _ic_4k = _interopRequireDefault(require("./ic_4k"));

var _ic_4g__plus__plus = _interopRequireDefault(require("./ic_4g__plus__plus"));

var _ic_4g__plus = _interopRequireDefault(require("./ic_4g__plus"));

var _ic_4g = _interopRequireDefault(require("./ic_4g"));

var _ic_5g = _interopRequireDefault(require("./ic_5g"));

var _ic_app_channel_management = _interopRequireDefault(require("./ic_app_channel_management"));

var _ic_app_channel_variety = _interopRequireDefault(require("./ic_app_channel_variety"));

var _ic_app_epg = _interopRequireDefault(require("./ic_app_epg"));

var _ic_app_epg_backwards = _interopRequireDefault(require("./ic_app_epg_backwards"));

var _ic_app_hd = _interopRequireDefault(require("./ic_app_hd"));

var _ic_app_tv = _interopRequireDefault(require("./ic_app_tv"));

var _ic_app_uhd = _interopRequireDefault(require("./ic_app_uhd"));

var _ic_app_vod = _interopRequireDefault(require("./ic_app_vod"));

var _ic_app_anytime = _interopRequireDefault(require("./ic_app_anytime"));

var _ic_app_cloud_dvr = _interopRequireDefault(require("./ic_app_cloud_dvr"));

var _ic_app_discovery = _interopRequireDefault(require("./ic_app_discovery"));

var _ic_app_kids = _interopRequireDefault(require("./ic_app_kids"));

var _ic_app_mediatheken = _interopRequireDefault(require("./ic_app_mediatheken"));

var _ic_app_mobile_entertainment = _interopRequireDefault(require("./ic_app_mobile_entertainment"));

var _ic_app_multiscreen = _interopRequireDefault(require("./ic_app_multiscreen"));

var _ic_app_restart = _interopRequireDefault(require("./ic_app_restart"));

var _ic_app_sideload = _interopRequireDefault(require("./ic_app_sideload"));

var _ic_app_swipe_to_tv = _interopRequireDefault(require("./ic_app_swipe_to_tv"));

var _ic_app_tv_for_you = _interopRequireDefault(require("./ic_app_tv_for_you"));

var _ic_app_videostore = _interopRequireDefault(require("./ic_app_videostore"));

var _ic_ar = _interopRequireDefault(require("./ic_ar"));

var _ic_convert_currency = _interopRequireDefault(require("./ic_convert_currency"));

var _ic_dwdm__muxer = _interopRequireDefault(require("./ic_dwdm__muxer"));

var _ic_giga_tv_a = _interopRequireDefault(require("./ic_giga_tv_a"));

var _ic_giga_tv_b = _interopRequireDefault(require("./ic_giga_tv_b"));

var _ic_impact__alert = _interopRequireDefault(require("./ic_impact__alert"));

var _ic_kippy__light = _interopRequireDefault(require("./ic_kippy__light"));

var _ic_make_payment = _interopRequireDefault(require("./ic_make_payment"));

var _ic_move__money = _interopRequireDefault(require("./ic_move__money"));

var _ic_move_money = _interopRequireDefault(require("./ic_move_money"));

var _ic_nfc = _interopRequireDefault(require("./ic_nfc"));

var _ic_tv_channel_management = _interopRequireDefault(require("./ic_tv_channel_management"));

var _ic_tv_channel_variety = _interopRequireDefault(require("./ic_tv_channel_variety"));

var _ic_tv_epg = _interopRequireDefault(require("./ic_tv_epg"));

var _ic_tv_epg_backwards = _interopRequireDefault(require("./ic_tv_epg_backwards"));

var _ic_tv_hd = _interopRequireDefault(require("./ic_tv_hd"));

var _ic_tv_primetime = _interopRequireDefault(require("./ic_tv_primetime"));

var _ic_tv_tv = _interopRequireDefault(require("./ic_tv_tv"));

var _ic_tv_time_flexible = _interopRequireDefault(require("./ic_tv_time_flexible"));

var _ic_tv_uhd = _interopRequireDefault(require("./ic_tv_uhd"));

var _ic_tv_vod = _interopRequireDefault(require("./ic_tv_vod"));

var _ic_tv_anytime = _interopRequireDefault(require("./ic_tv_anytime"));

var _ic_tv_bluetooth_remote_a = _interopRequireDefault(require("./ic_tv_bluetooth_remote_a"));

var _ic_tv_bluetooth_remote_b = _interopRequireDefault(require("./ic_tv_bluetooth_remote_b"));

var _ic_tv_cloud_dvr = _interopRequireDefault(require("./ic_tv_cloud_dvr"));

var _ic_tv_discovery = _interopRequireDefault(require("./ic_tv_discovery"));

var _ic_tv_everywhere = _interopRequireDefault(require("./ic_tv_everywhere"));

var _ic_tv_everywhere_home = _interopRequireDefault(require("./ic_tv_everywhere_home"));

var _ic_tv_for_you = _interopRequireDefault(require("./ic_tv_for_you"));

var _ic_tv_kids = _interopRequireDefault(require("./ic_tv_kids"));

var _ic_tv_mediatheken = _interopRequireDefault(require("./ic_tv_mediatheken"));

var _ic_tv_multiscreen = _interopRequireDefault(require("./ic_tv_multiscreen"));

var _ic_tv_restart = _interopRequireDefault(require("./ic_tv_restart"));

var _ic_tv_storage = _interopRequireDefault(require("./ic_tv_storage"));

var _ic_tv_videostore = _interopRequireDefault(require("./ic_tv_videostore"));

var _ic_withdraw_cash = _interopRequireDefault(require("./ic_withdraw_cash"));

var _ic_about = _interopRequireDefault(require("./ic_about"));

var _ic_abrupt__cornering = _interopRequireDefault(require("./ic_abrupt__cornering"));

var _ic_acceleration__low = _interopRequireDefault(require("./ic_acceleration__low"));

var _ic_accelerationdle = _interopRequireDefault(require("./ic_accelerationdle"));

var _ic_acceleration = _interopRequireDefault(require("./ic_acceleration"));

var _ic_accelerometer = _interopRequireDefault(require("./ic_accelerometer"));

var _ic_accessories = _interopRequireDefault(require("./ic_accessories"));

var _ic_activity = _interopRequireDefault(require("./ic_activity"));

var _ic_add__business__user = _interopRequireDefault(require("./ic_add__business__user"));

var _ic_add__friend = _interopRequireDefault(require("./ic_add__friend"));

var _ic_add__ons__boosts = _interopRequireDefault(require("./ic_add__ons__boosts"));

var _ic_add__or__plus = _interopRequireDefault(require("./ic_add__or__plus"));

var _ic_admin = _interopRequireDefault(require("./ic_admin"));

var _ic_adult = _interopRequireDefault(require("./ic_adult"));

var _ic_alarm__assistant__fire = _interopRequireDefault(require("./ic_alarm__assistant__fire"));

var _ic_alarm__assistant__leakage = _interopRequireDefault(require("./ic_alarm__assistant__leakage"));

var _ic_alarm__assistant = _interopRequireDefault(require("./ic_alarm__assistant"));

var _ic_alarm__system = _interopRequireDefault(require("./ic_alarm__system"));

var _ic_alexa = _interopRequireDefault(require("./ic_alexa"));

var _ic_all__rewards = _interopRequireDefault(require("./ic_all__rewards"));

var _ic_analyst__view = _interopRequireDefault(require("./ic_analyst__view"));

var _ic_android = _interopRequireDefault(require("./ic_android"));

var _ic_anti__shock = _interopRequireDefault(require("./ic_anti__shock"));

var _ic_app__anytime = _interopRequireDefault(require("./ic_app__anytime"));

var _ic_app__channel__management = _interopRequireDefault(require("./ic_app__channel__management"));

var _ic_app__channel__variety = _interopRequireDefault(require("./ic_app__channel__variety"));

var _ic_app__cloud__dvr = _interopRequireDefault(require("./ic_app__cloud__dvr"));

var _ic_app__discovery = _interopRequireDefault(require("./ic_app__discovery"));

var _ic_app__epg__backwards = _interopRequireDefault(require("./ic_app__epg__backwards"));

var _ic_app__epg = _interopRequireDefault(require("./ic_app__epg"));

var _ic_app__hd = _interopRequireDefault(require("./ic_app__hd"));

var _ic_app__kids = _interopRequireDefault(require("./ic_app__kids"));

var _ic_app__mediatheken = _interopRequireDefault(require("./ic_app__mediatheken"));

var _ic_app__mobile__entertainment = _interopRequireDefault(require("./ic_app__mobile__entertainment"));

var _ic_app__multiscreen = _interopRequireDefault(require("./ic_app__multiscreen"));

var _ic_app__restart = _interopRequireDefault(require("./ic_app__restart"));

var _ic_app__sideload = _interopRequireDefault(require("./ic_app__sideload"));

var _ic_app__store = _interopRequireDefault(require("./ic_app__store"));

var _ic_app__swipe__to__tv = _interopRequireDefault(require("./ic_app__swipe__to__tv"));

var _ic_app__tv__for__you = _interopRequireDefault(require("./ic_app__tv__for__you"));

var _ic_app__tv = _interopRequireDefault(require("./ic_app__tv"));

var _ic_app__uhd = _interopRequireDefault(require("./ic_app__uhd"));

var _ic_app__videostore = _interopRequireDefault(require("./ic_app__videostore"));

var _ic_app__vod = _interopRequireDefault(require("./ic_app__vod"));

var _ic_apps = _interopRequireDefault(require("./ic_apps"));

var _ic_arrow__down = _interopRequireDefault(require("./ic_arrow__down"));

var _ic_arrow__left = _interopRequireDefault(require("./ic_arrow__left"));

var _ic_arrow__right = _interopRequireDefault(require("./ic_arrow__right"));

var _ic_arrow__up = _interopRequireDefault(require("./ic_arrow__up"));

var _ic_attachment = _interopRequireDefault(require("./ic_attachment"));

var _ic_auto__top__up = _interopRequireDefault(require("./ic_auto__top__up"));

var _ic_backspace = _interopRequireDefault(require("./ic_backspace"));

var _ic_band__on__charge = _interopRequireDefault(require("./ic_band__on__charge"));

var _ic_barcode = _interopRequireDefault(require("./ic_barcode"));

var _ic_battery__low = _interopRequireDefault(require("./ic_battery__low"));

var _ic_battery__really__low = _interopRequireDefault(require("./ic_battery__really__low"));

var _ic_battery = _interopRequireDefault(require("./ic_battery"));

var _ic_bill__or__report = _interopRequireDefault(require("./ic_bill__or__report"));

var _ic_bill = _interopRequireDefault(require("./ic_bill"));

var _ic_biometric__authentication__new = _interopRequireDefault(require("./ic_biometric__authentication__new"));

var _ic_biometric_authentication = _interopRequireDefault(require("./ic_biometric_authentication"));

var _ic_birthday__greeting = _interopRequireDefault(require("./ic_birthday__greeting"));

var _ic_block = _interopRequireDefault(require("./ic_block"));

var _ic_blog = _interopRequireDefault(require("./ic_blog"));

var _ic_bluetooth = _interopRequireDefault(require("./ic_bluetooth"));

var _ic_bold = _interopRequireDefault(require("./ic_bold"));

var _ic_bolt = _interopRequireDefault(require("./ic_bolt"));

var _ic_book = _interopRequireDefault(require("./ic_book"));

var _ic_bookmark = _interopRequireDefault(require("./ic_bookmark"));

var _ic_boosting__pause = _interopRequireDefault(require("./ic_boosting__pause"));

var _ic_boosting = _interopRequireDefault(require("./ic_boosting"));

var _ic_bracelet__active = _interopRequireDefault(require("./ic_bracelet__active"));

var _ic_bracelet__disabled = _interopRequireDefault(require("./ic_bracelet__disabled"));

var _ic_bracelet__generic = _interopRequireDefault(require("./ic_bracelet__generic"));

var _ic_bracelet__not__found = _interopRequireDefault(require("./ic_bracelet__not__found"));

var _ic_bracelet__off = _interopRequireDefault(require("./ic_bracelet__off"));

var _ic_bracelet__on = _interopRequireDefault(require("./ic_bracelet__on"));

var _ic_bracelet__put__on = _interopRequireDefault(require("./ic_bracelet__put__on"));

var _ic_bracelet__remove = _interopRequireDefault(require("./ic_bracelet__remove"));

var _ic_braking = _interopRequireDefault(require("./ic_braking"));

var _ic_broadband__or__wifi = _interopRequireDefault(require("./ic_broadband__or__wifi"));

var _ic_broadband = _interopRequireDefault(require("./ic_broadband"));

var _ic_bullet__list = _interopRequireDefault(require("./ic_bullet__list"));

var _ic_bundles = _interopRequireDefault(require("./ic_bundles"));

var _ic_business__phone = _interopRequireDefault(require("./ic_business__phone"));

var _ic_business = _interopRequireDefault(require("./ic_business"));

var _ic_calculator = _interopRequireDefault(require("./ic_calculator"));

var _ic_calendar = _interopRequireDefault(require("./ic_calendar"));

var _ic_call__log = _interopRequireDefault(require("./ic_call__log"));

var _ic_call__quality__excellent = _interopRequireDefault(require("./ic_call__quality__excellent"));

var _ic_call__quality__good = _interopRequireDefault(require("./ic_call__quality__good"));

var _ic_call__quality__poor = _interopRequireDefault(require("./ic_call__quality__poor"));

var _ic_call = _interopRequireDefault(require("./ic_call"));

var _ic_calls__contacts = _interopRequireDefault(require("./ic_calls__contacts"));

var _ic_camera = _interopRequireDefault(require("./ic_camera"));

var _ic_car__key = _interopRequireDefault(require("./ic_car__key"));

var _ic_car = _interopRequireDefault(require("./ic_car"));

var _ic_careers = _interopRequireDefault(require("./ic_careers"));

var _ic_carer = _interopRequireDefault(require("./ic_carer"));

var _ic_case__study = _interopRequireDefault(require("./ic_case__study"));

var _ic_celebrate = _interopRequireDefault(require("./ic_celebrate"));

var _ic_charge__to__bill = _interopRequireDefault(require("./ic_charge__to__bill"));

var _ic_charity__giving = _interopRequireDefault(require("./ic_charity__giving"));

var _ic_chart__bar = _interopRequireDefault(require("./ic_chart__bar"));

var _ic_chart__line = _interopRequireDefault(require("./ic_chart__line"));

var _ic_chat = _interopRequireDefault(require("./ic_chat"));

var _ic_chatbot__robot = _interopRequireDefault(require("./ic_chatbot__robot"));

var _ic_cherries__points = _interopRequireDefault(require("./ic_cherries__points"));

var _ic_chevron__down = _interopRequireDefault(require("./ic_chevron__down"));

var _ic_chevron__left = _interopRequireDefault(require("./ic_chevron__left"));

var _ic_chevron__right = _interopRequireDefault(require("./ic_chevron__right"));

var _ic_chevron__up = _interopRequireDefault(require("./ic_chevron__up"));

var _ic_child__tracker = _interopRequireDefault(require("./ic_child__tracker"));

var _ic_chromecast = _interopRequireDefault(require("./ic_chromecast"));

var _ic_clapping = _interopRequireDefault(require("./ic_clapping"));

var _ic_click__collect = _interopRequireDefault(require("./ic_click__collect"));

var _ic_clock__or__timed = _interopRequireDefault(require("./ic_clock__or__timed"));

var _ic_clock = _interopRequireDefault(require("./ic_clock"));

var _ic_close = _interopRequireDefault(require("./ic_close"));

var _ic_cloud__download = _interopRequireDefault(require("./ic_cloud__download"));

var _ic_cloud__hosting = _interopRequireDefault(require("./ic_cloud__hosting"));

var _ic_cloud__upload = _interopRequireDefault(require("./ic_cloud__upload"));

var _ic_cluster__of__events = _interopRequireDefault(require("./ic_cluster__of__events"));

var _ic_colour__palette = _interopRequireDefault(require("./ic_colour__palette"));

var _ic_comment = _interopRequireDefault(require("./ic_comment"));

var _ic_community__or__foundation = _interopRequireDefault(require("./ic_community__or__foundation"));

var _ic_community = _interopRequireDefault(require("./ic_community"));

var _ic_compass = _interopRequireDefault(require("./ic_compass"));

var _ic_complaints = _interopRequireDefault(require("./ic_complaints"));

var _ic_completed = _interopRequireDefault(require("./ic_completed"));

var _ic_confidential = _interopRequireDefault(require("./ic_confidential"));

var _ic_connected__car = _interopRequireDefault(require("./ic_connected__car"));

var _ic_connected__devices = _interopRequireDefault(require("./ic_connected__devices"));

var _ic_connected = _interopRequireDefault(require("./ic_connected"));

var _ic_connectedices = _interopRequireDefault(require("./ic_connectedices"));

var _ic_connectivity = _interopRequireDefault(require("./ic_connectivity"));

var _ic_connects__home__to__phone = _interopRequireDefault(require("./ic_connects__home__to__phone"));

var _ic_consultant = _interopRequireDefault(require("./ic_consultant"));

var _ic_contactless__payment = _interopRequireDefault(require("./ic_contactless__payment"));

var _ic_contest = _interopRequireDefault(require("./ic_contest"));

var _ic_control__panel = _interopRequireDefault(require("./ic_control__panel"));

var _ic_converged__proposition = _interopRequireDefault(require("./ic_converged__proposition"));

var _ic_cost__control = _interopRequireDefault(require("./ic_cost__control"));

var _ic_country__or__international = _interopRequireDefault(require("./ic_country__or__international"));

var _ic_cpu = _interopRequireDefault(require("./ic_cpu"));

var _ic_customer__care = _interopRequireDefault(require("./ic_customer__care"));

var _ic_customers__or__users = _interopRequireDefault(require("./ic_customers__or__users"));

var _ic_cvv = _interopRequireDefault(require("./ic_cvv"));

var _ic_dashboard__in__app = _interopRequireDefault(require("./ic_dashboard__in__app"));

var _ic_dashboard = _interopRequireDefault(require("./ic_dashboard"));

var _ic_data = _interopRequireDefault(require("./ic_data"));

var _ic_deals = _interopRequireDefault(require("./ic_deals"));

var _ic_delete = _interopRequireDefault(require("./ic_delete"));

var _ic_delivery = _interopRequireDefault(require("./ic_delivery"));

var _ic_desktop = _interopRequireDefault(require("./ic_desktop"));

var _ic_device__diagnostics = _interopRequireDefault(require("./ic_device__diagnostics"));

var _ic_device__guide = _interopRequireDefault(require("./ic_device__guide"));

var _ic_device__overview__iot = _interopRequireDefault(require("./ic_device__overview__iot"));

var _ic_device__thickness = _interopRequireDefault(require("./ic_device__thickness"));

var _ic_diagnostics = _interopRequireDefault(require("./ic_diagnostics"));

var _ic_dial__pad = _interopRequireDefault(require("./ic_dial__pad"));

var _ic_dislike = _interopRequireDefault(require("./ic_dislike"));

var _ic_document__doc = _interopRequireDefault(require("./ic_document__doc"));

var _ic_document__jpg = _interopRequireDefault(require("./ic_document__jpg"));

var _ic_document__pdf = _interopRequireDefault(require("./ic_document__pdf"));

var _ic_document__png = _interopRequireDefault(require("./ic_document__png"));

var _ic_document__ppt = _interopRequireDefault(require("./ic_document__ppt"));

var _ic_document__rtf = _interopRequireDefault(require("./ic_document__rtf"));

var _ic_document__svg = _interopRequireDefault(require("./ic_document__svg"));

var _ic_document__xls = _interopRequireDefault(require("./ic_document__xls"));

var _ic_document__zip = _interopRequireDefault(require("./ic_document__zip"));

var _ic_document = _interopRequireDefault(require("./ic_document"));

var _ic_doorbell__camera = _interopRequireDefault(require("./ic_doorbell__camera"));

var _ic_double__stacked__pallet = _interopRequireDefault(require("./ic_double__stacked__pallet"));

var _ic_download__cloud = _interopRequireDefault(require("./ic_download__cloud"));

var _ic_download = _interopRequireDefault(require("./ic_download"));

var _ic_drone = _interopRequireDefault(require("./ic_drone"));

var _ic_e__sim = _interopRequireDefault(require("./ic_e__sim"));

var _ic_edit = _interopRequireDefault(require("./ic_edit"));

var _ic_end__call = _interopRequireDefault(require("./ic_end__call"));

var _ic_engineer = _interopRequireDefault(require("./ic_engineer"));

var _ic_enterprise = _interopRequireDefault(require("./ic_enterprise"));

var _ic_entertainment = _interopRequireDefault(require("./ic_entertainment"));

var _ic_environment = _interopRequireDefault(require("./ic_environment"));

var _ic_error__circle = _interopRequireDefault(require("./ic_error__circle"));

var _ic_error__simple = _interopRequireDefault(require("./ic_error__simple"));

var _ic_explorer = _interopRequireDefault(require("./ic_explorer"));

var _ic_extras__and__services = _interopRequireDefault(require("./ic_extras__and__services"));

var _ic_face__recognition = _interopRequireDefault(require("./ic_face__recognition"));

var _ic_facebook = _interopRequireDefault(require("./ic_facebook"));

var _ic_failed = _interopRequireDefault(require("./ic_failed"));

var _ic_fall__detection__emergency = _interopRequireDefault(require("./ic_fall__detection__emergency"));

var _ic_family = _interopRequireDefault(require("./ic_family"));

var _ic_filter = _interopRequireDefault(require("./ic_filter"));

var _ic_filters = _interopRequireDefault(require("./ic_filters"));

var _ic_find__and__ring__your__device = _interopRequireDefault(require("./ic_find__and__ring__your__device"));

var _ic_find__and__ring__yourice = _interopRequireDefault(require("./ic_find__and__ring__yourice"));

var _ic_find__my__car = _interopRequireDefault(require("./ic_find__my__car"));

var _ic_firmware__update = _interopRequireDefault(require("./ic_firmware__update"));

var _ic_fitness__tracker = _interopRequireDefault(require("./ic_fitness__tracker"));

var _ic_fixed__line = _interopRequireDefault(require("./ic_fixed__line"));

var _ic_focus = _interopRequireDefault(require("./ic_focus"));

var _ic_folder = _interopRequireDefault(require("./ic_folder"));

var _ic_forum = _interopRequireDefault(require("./ic_forum"));

var _ic_forward = _interopRequireDefault(require("./ic_forward"));

var _ic_free__delivery = _interopRequireDefault(require("./ic_free__delivery"));

var _ic_game__console = _interopRequireDefault(require("./ic_game__console"));

var _ic_generic__device__iot = _interopRequireDefault(require("./ic_generic__device__iot"));

var _ic_generic__tariff__plan = _interopRequireDefault(require("./ic_generic__tariff__plan"));

var _ic_genericice__iot = _interopRequireDefault(require("./ic_genericice__iot"));

var _ic_giga__tv__a = _interopRequireDefault(require("./ic_giga__tv__a"));

var _ic_giga__tv__b = _interopRequireDefault(require("./ic_giga__tv__b"));

var _ic_google__plus = _interopRequireDefault(require("./ic_google__plus"));

var _ic_gps__coverage = _interopRequireDefault(require("./ic_gps__coverage"));

var _ic_gravity = _interopRequireDefault(require("./ic_gravity"));

var _ic_grid__view = _interopRequireDefault(require("./ic_grid__view"));

var _ic_gyroscope = _interopRequireDefault(require("./ic_gyroscope"));

var _ic_healthy__living__favourites = _interopRequireDefault(require("./ic_healthy__living__favourites"));

var _ic_healthy__living = _interopRequireDefault(require("./ic_healthy__living"));

var _ic_help__at__hand = _interopRequireDefault(require("./ic_help__at__hand"));

var _ic_help__circle = _interopRequireDefault(require("./ic_help__circle"));

var _ic_help = _interopRequireDefault(require("./ic_help"));

var _ic_home = _interopRequireDefault(require("./ic_home"));

var _ic_idea__innovation = _interopRequireDefault(require("./ic_idea__innovation"));

var _ic_idea__or_innovation = _interopRequireDefault(require("./ic_idea__or_innovation"));

var _ic_idea__or__innovation__new = _interopRequireDefault(require("./ic_idea__or__innovation__new"));

var _ic_important__numbers = _interopRequireDefault(require("./ic_important__numbers"));

var _ic_incoming__call = _interopRequireDefault(require("./ic_incoming__call"));

var _ic_info__circle = _interopRequireDefault(require("./ic_info__circle"));

var _ic_info = _interopRequireDefault(require("./ic_info"));

var _ic_infographic = _interopRequireDefault(require("./ic_infographic"));

var _ic_insert__code = _interopRequireDefault(require("./ic_insert__code"));

var _ic_insights = _interopRequireDefault(require("./ic_insights"));

var _ic_insurance = _interopRequireDefault(require("./ic_insurance"));

var _ic_intelligence__scan = _interopRequireDefault(require("./ic_intelligence__scan"));

var _ic_interchangable__batteries = _interopRequireDefault(require("./ic_interchangable__batteries"));

var _ic_international__minutes = _interopRequireDefault(require("./ic_international__minutes"));

var _ic_internet__configurations = _interopRequireDefault(require("./ic_internet__configurations"));

var _ic_iris__scanner = _interopRequireDefault(require("./ic_iris__scanner"));

var _ic_italic = _interopRequireDefault(require("./ic_italic"));

var _ic_kids__watch = _interopRequireDefault(require("./ic_kids__watch"));

var _ic_kippy__device = _interopRequireDefault(require("./ic_kippy__device"));

var _ic_kippyice = _interopRequireDefault(require("./ic_kippyice"));

var _ic_landline__or__call = _interopRequireDefault(require("./ic_landline__or__call"));

var _ic_landline_internet = _interopRequireDefault(require("./ic_landline_internet"));

var _ic_lateral__movement = _interopRequireDefault(require("./ic_lateral__movement"));

var _ic_like = _interopRequireDefault(require("./ic_like"));

var _ic_link__insert__edit = _interopRequireDefault(require("./ic_link__insert__edit"));

var _ic_linkedin = _interopRequireDefault(require("./ic_linkedin"));

var _ic_list__view = _interopRequireDefault(require("./ic_list__view"));

var _ic_loan = _interopRequireDefault(require("./ic_loan"));

var _ic_locate__me = _interopRequireDefault(require("./ic_locate__me"));

var _ic_location__alert = _interopRequireDefault(require("./ic_location__alert"));

var _ic_location = _interopRequireDefault(require("./ic_location"));

var _ic_log__in = _interopRequireDefault(require("./ic_log__in"));

var _ic_log__out = _interopRequireDefault(require("./ic_log__out"));

var _ic_mail__new = _interopRequireDefault(require("./ic_mail__new"));

var _ic_mail__read = _interopRequireDefault(require("./ic_mail__read"));

var _ic_mail = _interopRequireDefault(require("./ic_mail"));

var _ic_map = _interopRequireDefault(require("./ic_map"));

var _ic_measure = _interopRequireDefault(require("./ic_measure"));

var _ic_members = _interopRequireDefault(require("./ic_members"));

var _ic_menu = _interopRequireDefault(require("./ic_menu"));

var _ic_merge__call = _interopRequireDefault(require("./ic_merge__call"));

var _ic_mesh__wifi__and__repeater = _interopRequireDefault(require("./ic_mesh__wifi__and__repeater"));

var _ic_message = _interopRequireDefault(require("./ic_message"));

var _ic_microphone = _interopRequireDefault(require("./ic_microphone"));

var _ic_minimize__image = _interopRequireDefault(require("./ic_minimize__image"));

var _ic_minus__or__less = _interopRequireDefault(require("./ic_minus__or__less"));

var _ic_minutes__sms = _interopRequireDefault(require("./ic_minutes__sms"));

var _ic_mobile__broadband = _interopRequireDefault(require("./ic_mobile__broadband"));

var _ic_mobile__signal__strength__excellent = _interopRequireDefault(require("./ic_mobile__signal__strength__excellent"));

var _ic_mobile__signal__strength__good = _interopRequireDefault(require("./ic_mobile__signal__strength__good"));

var _ic_mobile__signal__strength__marginal = _interopRequireDefault(require("./ic_mobile__signal__strength__marginal"));

var _ic_mobile__signal__strength__no__signal = _interopRequireDefault(require("./ic_mobile__signal__strength__no__signal"));

var _ic_mobile__signal__strength__ok = _interopRequireDefault(require("./ic_mobile__signal__strength__ok"));

var _ic_mobile = _interopRequireDefault(require("./ic_mobile"));

var _ic_monitor__brightness__contrast = _interopRequireDefault(require("./ic_monitor__brightness__contrast"));

var _ic_more__android = _interopRequireDefault(require("./ic_more__android"));

var _ic_more = _interopRequireDefault(require("./ic_more"));

var _ic_motion__alert = _interopRequireDefault(require("./ic_motion__alert"));

var _ic_motion__sensor = _interopRequireDefault(require("./ic_motion__sensor"));

var _ic_motion = _interopRequireDefault(require("./ic_motion"));

var _ic_multiscreen = _interopRequireDefault(require("./ic_multiscreen"));

var _ic_music__and__movies = _interopRequireDefault(require("./ic_music__and__movies"));

var _ic_mute = _interopRequireDefault(require("./ic_mute"));

var _ic_my__trips = _interopRequireDefault(require("./ic_my__trips"));

var _ic_my__vodafone__or__profile = _interopRequireDefault(require("./ic_my__vodafone__or__profile"));

var _ic_my__vodafone = _interopRequireDefault(require("./ic_my__vodafone"));

var _ic_need__help = _interopRequireDefault(require("./ic_need__help"));

var _ic_network__patch__panel = _interopRequireDefault(require("./ic_network__patch__panel"));

var _ic_network__signal = _interopRequireDefault(require("./ic_network__signal"));

var _ic_network = _interopRequireDefault(require("./ic_network"));

var _ic_newest__tech = _interopRequireDefault(require("./ic_newest__tech"));

var _ic_news = _interopRequireDefault(require("./ic_news"));

var _ic_night__vision = _interopRequireDefault(require("./ic_night__vision"));

var _ic_no__wifi = _interopRequireDefault(require("./ic_no__wifi"));

var _ic_notification__muted = _interopRequireDefault(require("./ic_notification__muted"));

var _ic_notification = _interopRequireDefault(require("./ic_notification"));

var _ic_number__ = _interopRequireDefault(require("./ic_number__0"));

var _ic_number__2 = _interopRequireDefault(require("./ic_number__1"));

var _ic_number__3 = _interopRequireDefault(require("./ic_number__2"));

var _ic_number__4 = _interopRequireDefault(require("./ic_number__3"));

var _ic_number__5 = _interopRequireDefault(require("./ic_number__4"));

var _ic_number__6 = _interopRequireDefault(require("./ic_number__5"));

var _ic_number__7 = _interopRequireDefault(require("./ic_number__6"));

var _ic_number__8 = _interopRequireDefault(require("./ic_number__7"));

var _ic_number__9 = _interopRequireDefault(require("./ic_number__8"));

var _ic_number__10 = _interopRequireDefault(require("./ic_number__9"));

var _ic_number__portability = _interopRequireDefault(require("./ic_number__portability"));

var _ic_numbered__view = _interopRequireDefault(require("./ic_numbered__view"));

var _ic_offer__badge__percent = _interopRequireDefault(require("./ic_offer__badge__percent"));

var _ic_offer__badge = _interopRequireDefault(require("./ic_offer__badge"));

var _ic_online__offers = _interopRequireDefault(require("./ic_online__offers"));

var _ic_online = _interopRequireDefault(require("./ic_online"));

var _ic_open__24__ = _interopRequireDefault(require("./ic_open__24__7"));

var _ic_optical__network__port = _interopRequireDefault(require("./ic_optical__network__port"));

var _ic_outgoing__call = _interopRequireDefault(require("./ic_outgoing__call"));

var _ic_padlock__close = _interopRequireDefault(require("./ic_padlock__close"));

var _ic_padlock__open = _interopRequireDefault(require("./ic_padlock__open"));

var _ic_parental__control = _interopRequireDefault(require("./ic_parental__control"));

var _ic_parking__ticket = _interopRequireDefault(require("./ic_parking__ticket"));

var _ic_password__key = _interopRequireDefault(require("./ic_password__key"));

var _ic_pause__circle = _interopRequireDefault(require("./ic_pause__circle"));

var _ic_pause = _interopRequireDefault(require("./ic_pause"));

var _ic_payg = _interopRequireDefault(require("./ic_payg"));

var _ic_payment = _interopRequireDefault(require("./ic_payment"));

var _ic_paypal = _interopRequireDefault(require("./ic_paypal"));

var _ic_pet__collar = _interopRequireDefault(require("./ic_pet__collar"));

var _ic_photos = _interopRequireDefault(require("./ic_photos"));

var _ic_pie__chart = _interopRequireDefault(require("./ic_pie__chart"));

var _ic_ping = _interopRequireDefault(require("./ic_ping"));

var _ic_play__arrow = _interopRequireDefault(require("./ic_play__arrow"));

var _ic_play__circle = _interopRequireDefault(require("./ic_play__circle"));

var _ic_play__store = _interopRequireDefault(require("./ic_play__store"));

var _ic_play = _interopRequireDefault(require("./ic_play"));

var _ic_plus = _interopRequireDefault(require("./ic_plus"));

var _ic_pop__in = _interopRequireDefault(require("./ic_pop__in"));

var _ic_pop__out = _interopRequireDefault(require("./ic_pop__out"));

var _ic_power = _interopRequireDefault(require("./ic_power"));

var _ic_prepare = _interopRequireDefault(require("./ic_prepare"));

var _ic_price__promise = _interopRequireDefault(require("./ic_price__promise"));

var _ic_price__tag = _interopRequireDefault(require("./ic_price__tag"));

var _ic_print = _interopRequireDefault(require("./ic_print"));

var _ic_privacy__confidential = _interopRequireDefault(require("./ic_privacy__confidential"));

var _ic_privacy__or__confidential = _interopRequireDefault(require("./ic_privacy__or__confidential"));

var _ic_privacy = _interopRequireDefault(require("./ic_privacy"));

var _ic_profile = _interopRequireDefault(require("./ic_profile"));

var _ic_public__sector = _interopRequireDefault(require("./ic_public__sector"));

var _ic_public__wifi = _interopRequireDefault(require("./ic_public__wifi"));

var _ic_qr__code = _interopRequireDefault(require("./ic_qr__code"));

var _ic_raffles = _interopRequireDefault(require("./ic_raffles"));

var _ic_rank__ace = _interopRequireDefault(require("./ic_rank__ace"));

var _ic_rank__badge__title = _interopRequireDefault(require("./ic_rank__badge__title"));

var _ic_rank__genius = _interopRequireDefault(require("./ic_rank__genius"));

var _ic_rank__guru = _interopRequireDefault(require("./ic_rank__guru"));

var _ic_rank__master = _interopRequireDefault(require("./ic_rank__master"));

var _ic_rank__networker = _interopRequireDefault(require("./ic_rank__networker"));

var _ic_rank__pioneer = _interopRequireDefault(require("./ic_rank__pioneer"));

var _ic_rank__pro = _interopRequireDefault(require("./ic_rank__pro"));

var _ic_rank__professor = _interopRequireDefault(require("./ic_rank__professor"));

var _ic_rank__savvy = _interopRequireDefault(require("./ic_rank__savvy"));

var _ic_rank__scout = _interopRequireDefault(require("./ic_rank__scout"));

var _ic_rank__virtuoso = _interopRequireDefault(require("./ic_rank__virtuoso"));

var _ic_rank__wizard = _interopRequireDefault(require("./ic_rank__wizard"));

var _ic_rank__writer = _interopRequireDefault(require("./ic_rank__writer"));

var _ic_rating__ = _interopRequireDefault(require("./ic_rating__0"));

var _ic_rating__2 = _interopRequireDefault(require("./ic_rating__5"));

var _ic_ratings__or__favourite = _interopRequireDefault(require("./ic_ratings__or__favourite"));

var _ic_ratings = _interopRequireDefault(require("./ic_ratings"));

var _ic_rearrange = _interopRequireDefault(require("./ic_rearrange"));

var _ic_recommend__drafts = _interopRequireDefault(require("./ic_recommend__drafts"));

var _ic_recommendation = _interopRequireDefault(require("./ic_recommendation"));

var _ic_redeemed__unlocked__rewards = _interopRequireDefault(require("./ic_redeemed__unlocked__rewards"));

var _ic_refresh = _interopRequireDefault(require("./ic_refresh"));

var _ic_reply = _interopRequireDefault(require("./ic_reply"));

var _ic_report = _interopRequireDefault(require("./ic_report"));

var _ic_reports = _interopRequireDefault(require("./ic_reports"));

var _ic_return__product = _interopRequireDefault(require("./ic_return__product"));

var _ic_roaming = _interopRequireDefault(require("./ic_roaming"));

var _ic_router = _interopRequireDefault(require("./ic_router"));

var _ic_safe__zone = _interopRequireDefault(require("./ic_safe__zone"));

var _ic_save = _interopRequireDefault(require("./ic_save"));

var _ic_saving = _interopRequireDefault(require("./ic_saving"));

var _ic_screen__repair = _interopRequireDefault(require("./ic_screen__repair"));

var _ic_screen__size = _interopRequireDefault(require("./ic_screen__size"));

var _ic_search = _interopRequireDefault(require("./ic_search"));

var _ic_secure__grip = _interopRequireDefault(require("./ic_secure__grip"));

var _ic_security__camera = _interopRequireDefault(require("./ic_security__camera"));

var _ic_security = _interopRequireDefault(require("./ic_security"));

var _ic_send__tobi = _interopRequireDefault(require("./ic_send__tobi"));

var _ic_senior = _interopRequireDefault(require("./ic_senior"));

var _ic_settings = _interopRequireDefault(require("./ic_settings"));

var _ic_setup = _interopRequireDefault(require("./ic_setup"));

var _ic_shake = _interopRequireDefault(require("./ic_shake"));

var _ic_share__your__mins = _interopRequireDefault(require("./ic_share__your__mins"));

var _ic_share = _interopRequireDefault(require("./ic_share"));

var _ic_shopping__checkout = _interopRequireDefault(require("./ic_shopping__checkout"));

var _ic_shopping__trolley = _interopRequireDefault(require("./ic_shopping__trolley"));

var _ic_shopping = _interopRequireDefault(require("./ic_shopping"));

var _ic_signed__in = _interopRequireDefault(require("./ic_signed__in"));

var _ic_sim__single = _interopRequireDefault(require("./ic_sim__single"));

var _ic_sim__swap = _interopRequireDefault(require("./ic_sim__swap"));

var _ic_sim = _interopRequireDefault(require("./ic_sim"));

var _ic_single__pallet = _interopRequireDefault(require("./ic_single__pallet"));

var _ic_small__and__lightweight = _interopRequireDefault(require("./ic_small__and__lightweight"));

var _ic_smart__plug = _interopRequireDefault(require("./ic_smart__plug"));

var _ic_smarthome__kit = _interopRequireDefault(require("./ic_smarthome__kit"));

var _ic_sme = _interopRequireDefault(require("./ic_sme"));

var _ic_smiley = _interopRequireDefault(require("./ic_smiley"));

var _ic_sms = _interopRequireDefault(require("./ic_sms"));

var _ic_social__chat = _interopRequireDefault(require("./ic_social__chat"));

var _ic_social__facebook = _interopRequireDefault(require("./ic_social__facebook"));

var _ic_social__google__plus = _interopRequireDefault(require("./ic_social__google__plus"));

var _ic_social__instagram = _interopRequireDefault(require("./ic_social__instagram"));

var _ic_social__linkedin = _interopRequireDefault(require("./ic_social__linkedin"));

var _ic_social__paypal = _interopRequireDefault(require("./ic_social__paypal"));

var _ic_social__pinterest = _interopRequireDefault(require("./ic_social__pinterest"));

var _ic_social__twitter = _interopRequireDefault(require("./ic_social__twitter"));

var _ic_social__whatsapp = _interopRequireDefault(require("./ic_social__whatsapp"));

var _ic_social__youtube = _interopRequireDefault(require("./ic_social__youtube"));

var _ic_soho = _interopRequireDefault(require("./ic_soho"));

var _ic_solution__finder = _interopRequireDefault(require("./ic_solution__finder"));

var _ic_sort = _interopRequireDefault(require("./ic_sort"));

var _ic_sos__credit__topup = _interopRequireDefault(require("./ic_sos__credit__topup"));

var _ic_sos__credit = _interopRequireDefault(require("./ic_sos__credit"));

var _ic_sos__emergency = _interopRequireDefault(require("./ic_sos__emergency"));

var _ic_sound__active = _interopRequireDefault(require("./ic_sound__active"));

var _ic_sound__off = _interopRequireDefault(require("./ic_sound__off"));

var _ic_sound = _interopRequireDefault(require("./ic_sound"));

var _ic_speeding = _interopRequireDefault(require("./ic_speeding"));

var _ic_spell__check = _interopRequireDefault(require("./ic_spell__check"));

var _ic_spinner = _interopRequireDefault(require("./ic_spinner"));

var _ic_steering__wheel = _interopRequireDefault(require("./ic_steering__wheel"));

var _ic_stop__circle = _interopRequireDefault(require("./ic_stop__circle"));

var _ic_stop = _interopRequireDefault(require("./ic_stop"));

var _ic_storage = _interopRequireDefault(require("./ic_storage"));

var _ic_store__offers = _interopRequireDefault(require("./ic_store__offers"));

var _ic_strike__through = _interopRequireDefault(require("./ic_strike__through"));

var _ic_student = _interopRequireDefault(require("./ic_student"));

var _ic_superstar = _interopRequireDefault(require("./ic_superstar"));

var _ic_support = _interopRequireDefault(require("./ic_support"));

var _ic_surveillance__camera = _interopRequireDefault(require("./ic_surveillance__camera"));

var _ic_switch__call = _interopRequireDefault(require("./ic_switch__call"));

var _ic_sync = _interopRequireDefault(require("./ic_sync"));

var _ic_tablet = _interopRequireDefault(require("./ic_tablet"));

var _ic_tail = _interopRequireDefault(require("./ic_tail"));

var _ic_tethering = _interopRequireDefault(require("./ic_tethering"));

var _ic_text = _interopRequireDefault(require("./ic_text"));

var _ic_tick__or__solved = _interopRequireDefault(require("./ic_tick__or__solved"));

var _ic_tick__outline = _interopRequireDefault(require("./ic_tick__outline"));

var _ic_tick = _interopRequireDefault(require("./ic_tick"));

var _ic_top__up = _interopRequireDefault(require("./ic_top__up"));

var _ic_topics = _interopRequireDefault(require("./ic_topics"));

var _ic_touch__screen = _interopRequireDefault(require("./ic_touch__screen"));

var _ic_tracker = _interopRequireDefault(require("./ic_tracker"));

var _ic_trackisafe = _interopRequireDefault(require("./ic_trackisafe"));

var _ic_translate = _interopRequireDefault(require("./ic_translate"));

var _ic_tutorials = _interopRequireDefault(require("./ic_tutorials"));

var _ic_tv__anytime = _interopRequireDefault(require("./ic_tv__anytime"));

var _ic_tv__bluetooth__remote__a = _interopRequireDefault(require("./ic_tv__bluetooth__remote__a"));

var _ic_tv__bluetooth__remote__b = _interopRequireDefault(require("./ic_tv__bluetooth__remote__b"));

var _ic_tv__channel__management = _interopRequireDefault(require("./ic_tv__channel__management"));

var _ic_tv__channel__variety = _interopRequireDefault(require("./ic_tv__channel__variety"));

var _ic_tv__cloud__dvr = _interopRequireDefault(require("./ic_tv__cloud__dvr"));

var _ic_tv__discovery = _interopRequireDefault(require("./ic_tv__discovery"));

var _ic_tv__epg__backwards = _interopRequireDefault(require("./ic_tv__epg__backwards"));

var _ic_tv__epg = _interopRequireDefault(require("./ic_tv__epg"));

var _ic_tv__everywhere__home = _interopRequireDefault(require("./ic_tv__everywhere__home"));

var _ic_tv__everywhere = _interopRequireDefault(require("./ic_tv__everywhere"));

var _ic_tv__for__you = _interopRequireDefault(require("./ic_tv__for__you"));

var _ic_tv__hd = _interopRequireDefault(require("./ic_tv__hd"));

var _ic_tv__kids = _interopRequireDefault(require("./ic_tv__kids"));

var _ic_tv__mediatheken = _interopRequireDefault(require("./ic_tv__mediatheken"));

var _ic_tv__multiscreen = _interopRequireDefault(require("./ic_tv__multiscreen"));

var _ic_tv__primetime = _interopRequireDefault(require("./ic_tv__primetime"));

var _ic_tv__remote = _interopRequireDefault(require("./ic_tv__remote"));

var _ic_tv__restart = _interopRequireDefault(require("./ic_tv__restart"));

var _ic_tv__storage = _interopRequireDefault(require("./ic_tv__storage"));

var _ic_tv__time__flexible = _interopRequireDefault(require("./ic_tv__time__flexible"));

var _ic_tv__tv = _interopRequireDefault(require("./ic_tv__tv"));

var _ic_tv__uhd = _interopRequireDefault(require("./ic_tv__uhd"));

var _ic_tv__videostore = _interopRequireDefault(require("./ic_tv__videostore"));

var _ic_tv__vod = _interopRequireDefault(require("./ic_tv__vod"));

var _ic_tv = _interopRequireDefault(require("./ic_tv"));

var _ic_underlined = _interopRequireDefault(require("./ic_underlined"));

var _ic_unified__communication = _interopRequireDefault(require("./ic_unified__communication"));

var _ic_unlimited = _interopRequireDefault(require("./ic_unlimited"));

var _ic_unlock__reward = _interopRequireDefault(require("./ic_unlock__reward"));

var _ic_upgrade = _interopRequireDefault(require("./ic_upgrade"));

var _ic_upload__cloud = _interopRequireDefault(require("./ic_upload__cloud"));

var _ic_upload = _interopRequireDefault(require("./ic_upload"));

var _ic_usb = _interopRequireDefault(require("./ic_usb"));

var _ic_usb_modem = _interopRequireDefault(require("./ic_usb_modem"));

var _ic_user__log__in = _interopRequireDefault(require("./ic_user__log__in"));

var _ic_users = _interopRequireDefault(require("./ic_users"));

var _ic_v__baby = _interopRequireDefault(require("./ic_v__baby"));

var _ic_v__bag = _interopRequireDefault(require("./ic_v__bag"));

var _ic_v__car__dongle = _interopRequireDefault(require("./ic_v__car__dongle"));

var _ic_v__home__monitor = _interopRequireDefault(require("./ic_v__home__monitor"));

var _ic_v__kids = _interopRequireDefault(require("./ic_v__kids"));

var _ic_v__pet = _interopRequireDefault(require("./ic_v__pet"));

var _ic_v__sim__and__device = _interopRequireDefault(require("./ic_v__sim__and__device"));

var _ic_v__sim__andice = _interopRequireDefault(require("./ic_v__sim__andice"));

var _ic_video__cloud = _interopRequireDefault(require("./ic_video__cloud"));

var _ic_video = _interopRequireDefault(require("./ic_video"));

var _ic_viewed = _interopRequireDefault(require("./ic_viewed"));

var _ic_virtual__device = _interopRequireDefault(require("./ic_virtual__device"));

var _ic_virtualice = _interopRequireDefault(require("./ic_virtualice"));

var _ic_virus__protection = _interopRequireDefault(require("./ic_virus__protection"));

var _ic_vodafone__logo__white = _interopRequireDefault(require("./ic_vodafone__logo__white"));

var _ic_vodafone__logo = _interopRequireDefault(require("./ic_vodafone__logo"));

var _ic_vodafone__store = _interopRequireDefault(require("./ic_vodafone__store"));

var _ic_vodafone = _interopRequireDefault(require("./ic_vodafone"));

var _ic_voice__of__vodafone__alerts = _interopRequireDefault(require("./ic_voice__of__vodafone__alerts"));

var _ic_voicemail = _interopRequireDefault(require("./ic_voicemail"));

var _ic_warning = _interopRequireDefault(require("./ic_warning"));

var _ic_watch = _interopRequireDefault(require("./ic_watch"));

var _ic_waterproof = _interopRequireDefault(require("./ic_waterproof"));

var _ic_web__protection = _interopRequireDefault(require("./ic_web__protection"));

var _ic_webcamera = _interopRequireDefault(require("./ic_webcamera"));

var _ic_website = _interopRequireDefault(require("./ic_website"));

var _ic_weight = _interopRequireDefault(require("./ic_weight"));

var _ic_white__paper = _interopRequireDefault(require("./ic_white__paper"));

var _ic_wifi__good = _interopRequireDefault(require("./ic_wifi__good"));

var _ic_wifi__medium = _interopRequireDefault(require("./ic_wifi__medium"));

var _ic_wifi__poor = _interopRequireDefault(require("./ic_wifi__poor"));

var _ic_wiring__connections = _interopRequireDefault(require("./ic_wiring__connections"));

var _ic_world = _interopRequireDefault(require("./ic_world"));

var _ic_writer = _interopRequireDefault(require("./ic_writer"));

var _ic_zoom__in = _interopRequireDefault(require("./ic_zoom__in"));

var _ic_zoom__out = _interopRequireDefault(require("./ic_zoom__out"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }